import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { LABELS } from '../../../../../shared/constants/lables.constants';
import { ButtonComponent, CheckboxComponent, DateInputComponent, FileTextUploadComponent, PhoneMaskDirective, SelectInputComponent, SelectOption, TextInputComponent } from 'ddmo-storybook-lib';
import { CommonModule, DatePipe } from '@angular/common';
import { SharedService } from '../../../../../shared/services/shared.service';
import $ from 'jquery';
import { LoaderService } from '../../../../../shared/services/loader.service';
import { v4 as uuidv4 } from 'uuid';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../../popup/popup.component';
import { DocumentCategory, DocumentSubCategory, DocumentSubCategoryName } from '../../../../../shared/constants/document.constants';
import { DentalCredentialsService } from '../../../services/dental-credentials.service';
import { Router } from '@angular/router';
import { W9AlertComponent } from '../../../../popups/processing/processing.component';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-create-tin',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, SelectInputComponent, TextInputComponent, DateInputComponent,
    ButtonComponent, PhoneMaskDirective, CheckboxComponent, FileTextUploadComponent],
  templateUrl: './create-tin.component.html',
  styleUrl: './create-tin.component.scss'
})
export class CreateTinComponent implements OnInit {

  PHONE_PATTERN = LABELS.PHONE_PATTERN;
  EMAIL_PATTERN = LABELS.EMAIL_PTTERN;

  taxIdTypes: SelectOption[] = [
    { value: '1', viewValue: 'SSN' },
    { value: '2', viewValue: 'EIN' }
  ]
  stateOptions: SelectOption[] = LABELS.STATE_CODES_LIST

  FIELD_LIMITS = {
    taxId: { type: 'number', maxLength: 9 },
    taxEntityName: { type: 'string', maxLength: 80 },
    location: { type: 'string', maxLength: 55 },
    address2: { type: 'string', maxLength: 55 },
    city: { type: 'string', maxLength: 50 },
    zip: { type: 'string', maxLength: 5 },
    phone: { type: 'string', maxLength: 14 },
    payeeName: { type: 'string', maxLength: 80 },
    payeeLocation: { type: 'string', maxLength: 55 },
    payeeAddress2: { type: 'string', maxLength: 55 },
    payeeCity: { type: 'string', maxLength: 50 },
    payeeState: { type: 'string', maxLength: 2 },
    payeeZip: { type: 'string', maxLength: 5 },
    payeePhone: { type: 'string', maxLength: 14 },
    payeeEmail: { type: 'string', maxLength: 90 },
    npi2: { type: 'string', maxLength: 10 },
  }
  minDate = new Date(
    new Date().getFullYear() - 2,
    new Date().getMonth(),
    new Date().getDate()
  );

  suggestionCount: any = 0;
  private scrollHandler = this.onScroll.bind(this);
  selectedAddress: any = '';
  isTinFromDW = false;
  showFulladdressError = false
  showFulladdressErrorPayee = false
  isPlaceSelected: boolean = false;
  showError: boolean = false;
  showErrorPayee: boolean = false;
  w9DocumentId: any = null;
  W9fileName = '';
  showStateError: boolean = false
  showDocError: boolean = false;
  showW9Asterisk: boolean = true;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('w9Upload') w9Upload?: FileTextUploadComponent;
  @ViewChildren('locationInput') locationInputs!: QueryList<ElementRef>;
  @Input() accept = 'application/pdf';
  @Input() serviceCheckFormInput?: FormGroup;
  @Input() locationFormGroupInput?: FormGroup;
  @Input() locationMetaInput?: any;
  @Input() showW9Section = true;
  @Input() showSaveAction = true;
  @Input() isW9Required = true;
  @Input() shouldDeleteW9OnSave = false;
  @Output() saveCompleted = new EventEmitter<void>();
  @Output() corpAuthCleared = new EventEmitter<void>();
  beforeFormData: any;
  existingPayeeOptions: SelectOption[] = [];
  private existingPayees: any[] = [];
  selectedExistingPayeeControl = new FormControl('');
  private readonly SEARCH_TIN_TAX_ENTITY_KEY = 'SearchTINTaxEntityDetails';
  private readonly SEARCH_TIN_TAX_ENTITY_TIN_KEY = 'SearchTINTaxEntityTin';
  private readonly DIRECTORY_INFO_SIGNED_KEY = 'directoryInfoSigned';
  private readonly PENDING_LOCATION_DIRECTORY_DATA_KEY = 'pendingLocationDirectoryData';
  private readonly EXISTING_PAYEE_SELECTION_KEY_PREFIX = 'selectedExistingPayeeAddress';

  get serviceCheckForm(): FormGroup {
    return this.serviceCheckFormInput ?? this.ServiceCheckForm;
  }

  constructor(private sharedService: SharedService, private ngZone: NgZone, private loaderService: LoaderService,
    private dialog: MatDialog, private dentalCredentialingService: DentalCredentialsService, private router: Router,
    private fb: FormBuilder, private datePipe: DatePipe) { }

  private getStorageArray(key: string): any[] {
    const parsed = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(parsed)) return parsed;
    return parsed ? [parsed] : [];
  }

  public tinFormGroup = new FormGroup({
    taxIdType: new FormControl('', [Validators.required]),
    taxId: new FormControl('', [Validators.required, Validators.minLength(9), Validators.maxLength(9)]),
    taxEntityName: new FormControl('', [Validators.required, Validators.maxLength(80)]),
    location: new FormControl('', [Validators.required, Validators.maxLength(55)]),
    address2: new FormControl('', [Validators.maxLength(55)]),
    city: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    state: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]),
    zip: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]),
    phone: new FormControl('', [Validators.required, Validators.pattern(this.PHONE_PATTERN)]),
    effectiveDate: new FormControl<Date | string>('', [Validators.required, this.effectiveDateBeforeOrOnLocationStartDateValidator.bind(this)]),
    w9Control: new FormControl('', [])
  });

  public payeeFormGroup = new FormGroup({
    payeeName: new FormControl('', [Validators.required, Validators.maxLength(80)]),
    payeeLocation: new FormControl('', [Validators.required, Validators.maxLength(55)]),
    payeeAddress2: new FormControl('', [Validators.maxLength(55)]),
    payeeCity: new FormControl('', [Validators.required, Validators.maxLength(50)]),
    payeeState: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]),
    payeeZip: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]),
    payeePhone: new FormControl('', [Validators.required, Validators.pattern(this.PHONE_PATTERN)]),
    payeeEmail: new FormControl('', [Validators.pattern(this.EMAIL_PATTERN)]),
    npi2: new FormControl('', [Validators.minLength(10), Validators.maxLength(10)]),
  });

  public ServiceCheckForm = this.fb.group({
    serviceLocationChecked: [false]
  })

  VALIDATION_MESSAGES: any = {
    zip: {
      required: 'Required',
      minlength: LABELS.ERROR_MESSAGES.minimumFiveCharecter
    },
    taxId: {
      required: 'Required',
      minlength: LABELS.ERROR_MESSAGES.minimumNineCharecter
    },
    npi2: {
      minlength: 'Please enter a minimum of 10 characters'
    },
    effectiveDate: {
      required: 'Required',
      matDatepickerParse: 'Enter a valid date',
      matDatepickerMin: 'Effective date cannot be older than 2 years.',
      minDate: 'Effective date cannot be older than 2 years.',
      pattern: 'Enter a valid date',
      effectiveDateBeforeOrOnLocationStartDate: 'Effective date must be on or before the location start date.'
    }
  }
  TINdata: any
  isW9Alert: boolean = false;
  payeeID: any
  w9Documents: any[] = [];
  directoryData: any;
  directoryArray: any[] = [];
  editTinData: any
  isEditMode = false;
  isSaved = false;
  latestlocation: any
  impersonatedUser: any;
  private locationFormSyncSubscription?: Subscription;
  isReadOnlyTinSearchFlow = false;
  isExistingTinNewLocationFlow = false;
  isLocationEditMode = false;

  get isMergedLocationEditMode(): boolean {
    return this.isLocationEditMode && !!this.locationMetaInput?.isMergedLocationEditMode;
  }

  get isDwLocationEditMode(): boolean {
    return !!this.locationMetaInput?.isDwLocationEditMode;
  }

  get isDwMergedLocationEditMode(): boolean {
    return this.isMergedLocationEditMode && this.isDwLocationEditMode;
  }

  private shouldPreserveLockedMergedTinValues(): boolean {
    return this.isMergedLocationEditMode &&
      !this.isExistingTinNewLocationFlow &&
      (!!this.locationMetaInput?.lockTinFieldsOnEdit || this.isTinFromDW);
  }

  get showServiceLocationCheckbox(): boolean {
    return !this.isReadOnlyTinSearchFlow && !this.isDwMergedLocationEditMode;
  }

  get hasExistingPayeeSelection(): boolean {
    const selectedPayeeValue = this.selectedExistingPayeeControl.value;
    return selectedPayeeValue !== null && selectedPayeeValue !== undefined && `${selectedPayeeValue}` !== '';
  }

  private syncExistingPayeeSelectionControlState() {
    if (!this.isExistingTinNewLocationFlow) {
      return;
    }

    if (this.impersonatedUser || !this.existingPayeeOptions.length) {
      this.selectedExistingPayeeControl.disable({ emitEvent: false });
      return;
    }

    const isServiceLocationChecked = !!this.serviceCheckForm.get('serviceLocationChecked')?.value;
    if (isServiceLocationChecked) {
      this.selectedExistingPayeeControl.disable({ emitEvent: false });
      return;
    }

    this.selectedExistingPayeeControl.enable({ emitEvent: false });
  }

  private getExistingPayeeSelectionStorageKey(): string {
    const selectedTin = this.getFirstNonEmpty(this.TINdata, ['taxId', 'tin']) ||
      this.locationFormGroupInput?.get('tin')?.value ||
      localStorage.getItem('SearchedTin') ||
      '';
    const locationLookupId = this.locationMetaInput?.locationLookupId ??
      this.locationMetaInput?.locationId ??
      this.locationMetaInput?.esLocationId ??
      'new';
    return `${this.EXISTING_PAYEE_SELECTION_KEY_PREFIX}:${selectedTin}:${locationLookupId}`;
  }

  private getLegacyNewExistingPayeeSelectionStorageKey(): string {
    const selectedTin = this.getFirstNonEmpty(this.TINdata, ['taxId', 'tin']) ||
      this.locationFormGroupInput?.get('tin')?.value ||
      localStorage.getItem('SearchedTin') ||
      '';
    return `${this.EXISTING_PAYEE_SELECTION_KEY_PREFIX}:${selectedTin}:new`;
  }

  private getStoredExistingPayeeSelectionAddress(): string {
    const currentKeyValue = `${localStorage.getItem(this.getExistingPayeeSelectionStorageKey()) || ''}`.trim();
    if (currentKeyValue) {
      return currentKeyValue;
    }
    return `${localStorage.getItem(this.getLegacyNewExistingPayeeSelectionStorageKey()) || ''}`.trim();
  }

  private setStoredExistingPayeeSelectionAddress(address: string | null) {
    const storageKey = this.getExistingPayeeSelectionStorageKey();
    const legacyStorageKey = this.getLegacyNewExistingPayeeSelectionStorageKey();
    const normalizedAddress = `${address || ''}`.trim();
    if (normalizedAddress) {
      localStorage.setItem(storageKey, normalizedAddress);
      return;
    }
    localStorage.removeItem(storageKey);
    if (legacyStorageKey !== storageKey) {
      localStorage.removeItem(legacyStorageKey);
    }
  }

  private shouldSkipPayeeToTinSync(): boolean {
    return this.isExistingTinNewLocationFlow ||
      this.isMergedLocationEditMode ||
      this.isDwMergedLocationEditMode ||
      this.shouldPreserveLockedMergedTinValues() ||
      this.tinFormGroup.disabled;
  }

  private effectiveDateBeforeOrOnLocationStartDateValidator(control: AbstractControl): ValidationErrors | null {
    if (localStorage.getItem('isnewTIN') !== 'true') {
      return null;
    }
    if (!control.value) {
      return null;
    }

    const locationStartDateValue =
      this.locationFormGroupInput?.get('startDate')?.value ??
      this.latestlocation?.[0]?.startPracticingAt ??
      null;

    if (!locationStartDateValue) {
      return null;
    }

    const effectiveDate = this.toComparableDate(control.value);
    const locationStartDate = this.toComparableDate(locationStartDateValue);

    if (!effectiveDate || !locationStartDate) {
      return null;
    }

    return effectiveDate <= locationStartDate
      ? null
      : { effectiveDateBeforeOrOnLocationStartDate: true };
  }

  private toComparableDate(value: any): Date | null {
    if (!value) {
      return null;
    }
    const normalizedValue =
      typeof value === 'string' && /^\d{8}$/.test(value.trim())
        ? `${value.trim().slice(0, 4)}-${value.trim().slice(4, 6)}-${value.trim().slice(6, 8)}`
        : value;
    const date = new Date(normalizedValue);
    if (isNaN(date.getTime())) {
      return null;
    }
    date.setHours(0, 0, 0, 0);
    return date;
  }

  ngOnInit(): void {
    this.impersonatedUser = localStorage.getItem("impersonatedUser") ?? ""
    this.isExistingTinNewLocationFlow = !!this.locationMetaInput?.isExistingTinNewLocationFlow;
    this.isLocationEditMode = !!this.locationMetaInput?.isLocationEditMode;
    this.tinFormGroup.get('taxEntityName')?.disable()
    this.payeeFormGroup.get('payeeName')?.disable();
    this.initializeLocationNameBinding();
    this.locationFormGroupInput?.get('startDate')?.valueChanges.subscribe(() => {
      this.tinFormGroup.get('effectiveDate')?.updateValueAndValidity({ emitEvent: false });
    });
    this.payeeFormGroup.get("payeePhone")?.valueChanges.subscribe(value => {
      const shouldSkipSync = this.shouldSkipPayeeToTinSync();
      if (shouldSkipSync) {
        return;
      }
      this.tinFormGroup.patchValue(
        { phone: value },
        { emitEvent: false }
      );
    });
    this.payeeFormGroup.get("payeeLocation")?.valueChanges.subscribe(value => {
      const shouldSkipSync = this.shouldSkipPayeeToTinSync();
      if (shouldSkipSync) {
        return;
      }
      this.tinFormGroup.patchValue(
        { location: value },
        { emitEvent: false }
      );
    });
    this.payeeFormGroup.get("payeeAddress2")?.valueChanges.subscribe(value => {
      const shouldSkipSync = this.shouldSkipPayeeToTinSync();
      if (shouldSkipSync) {
        return;
      }
      this.tinFormGroup.patchValue(
        { address2: value },
        { emitEvent: false }
      );
    });
    this.payeeFormGroup.get("payeeCity")?.valueChanges.subscribe(value => {
      const shouldSkipSync = this.shouldSkipPayeeToTinSync();
      if (shouldSkipSync) {
        return;
      }
      this.tinFormGroup.patchValue(
        { city: value },
        { emitEvent: false }
      );
    });
    this.payeeFormGroup.get("payeeState")?.valueChanges.subscribe(value => {
      const shouldSkipSync = this.shouldSkipPayeeToTinSync();
      if (shouldSkipSync) {
        return;
      }
      this.tinFormGroup.patchValue(
        { state: value },
        { emitEvent: false }
      );
    });
    this.payeeFormGroup.get("payeeZip")?.valueChanges.subscribe(value => {
      const shouldSkipSync = this.shouldSkipPayeeToTinSync();
      if (shouldSkipSync) {
        return;
      }
      this.tinFormGroup.patchValue(
        { zip: value },
        { emitEvent: false }
      );
    });
    this.serviceCheckForm.get('serviceLocationChecked')?.valueChanges.subscribe((isChecked) => {
      this.applyServiceLocationToggle(!!isChecked);
    });
    this.selectedExistingPayeeControl.valueChanges.subscribe(() => {
      if (!this.isExistingTinNewLocationFlow) {
        return;
      }
      this.updateServiceLocationCheckboxState();
    });
    this.initializeServiceLocationSync();
    let directoryqns = localStorage.getItem('locationDirectories')
    this.directoryArray = directoryqns ? JSON.parse(directoryqns) : []
    if (localStorage.getItem('isW9Alert') && localStorage.getItem('isW9Alert') == 'true') {
      this.isW9Alert = true;
      this.bindFormData(false)
    } else if (localStorage.getItem('isTINEditMode') && localStorage.getItem('isTINEditMode') == "true") {
      this.editTinData = JSON.parse(localStorage.getItem("editTinData") || '{}')
      this.isEditMode = true
      this.bindFormData(true)
    } else if (localStorage.getItem('isnewTIN') && localStorage.getItem('isnewTIN') == "true") {
      const draftLocationRecords = JSON.parse(localStorage.getItem('LocationSavePayload') || '{}');
      if (draftLocationRecords && draftLocationRecords.length > 0) {
        const latestLocationrecord = draftLocationRecords.filter((location: any) => location.locationId == null)
        this.latestlocation = latestLocationrecord
        this.bindFormUsingLatestLocationRecord()
      }
      const searchedTIN = localStorage.getItem('SearchedTin') || this.locationFormGroupInput?.get('tin')?.value || '';
      if (searchedTIN) {
        this.tinFormGroup.patchValue({
          taxId: searchedTIN
        });
      }
      this.tinFormGroup.get('taxId')?.disable();
    } else if (
      !!this.locationMetaInput?.isLocationFromTinSearch &&
      !!this.locationFormGroupInput &&
      !(this.locationMetaInput?.isLocationEditMode && this.locationMetaInput?.isMergedLocationEditMode)
    ) {
      this.isReadOnlyTinSearchFlow = true;
      this.bindFormData(false);
      this.enforceReadOnlyTinAndPayeeSections();
    } else if (
      !!this.locationMetaInput?.isExistingTinNewLocationFlow &&
      !!this.locationFormGroupInput
    ) {
      this.isReadOnlyTinSearchFlow = false;
      this.bindFormData(false);
      this.initializeExistingPayeeOptions();
      if (this.isLocationEditMode) {
        this.preparePayeeForExistingTinNewLocationEdit();
      } else {
        this.preparePayeeForExistingTinNewLocation();
      }
    } else if (
      !!this.locationMetaInput?.isLocationEditMode &&
      !!this.locationMetaInput?.isMergedLocationEditMode &&
      !!this.locationFormGroupInput
    ) {
      this.isReadOnlyTinSearchFlow = false;
      this.bindFormData(false);
      if (!this.isDwMergedLocationEditMode) {
        if (!this.impersonatedUser) {
          this.serviceCheckForm.enable({ emitEvent: false });
        }
        const isServiceLocationChecked = !!this.serviceCheckForm.get('serviceLocationChecked')?.value;
        this.setPayeeEditState(isServiceLocationChecked);
      }
    }
  }
  restrictNonNumeric(event: KeyboardEvent): void {
    this.sharedService.preventNonNumeric(event);
  }
  restrictNonNumericPaste(event: ClipboardEvent): void {
    this.sharedService.preventNonNumbericForPaste(event);
}

  onServiceLocationToggle(event?: any) {
    const isChecked = !!this.serviceCheckForm.get('serviceLocationChecked')?.value;
    this.applyServiceLocationToggle(isChecked);
  }

  applyServiceLocationToggle(isChecked: boolean) {
    if (this.isReadOnlyTinSearchFlow) {
      return;
    }
    if (this.isDwMergedLocationEditMode) {
      return;
    }
    if (this.isExistingTinNewLocationFlow) {
      if (isChecked) {
        this.selectedExistingPayeeControl.setValue('', { emitEvent: false });
        this.setStoredExistingPayeeSelectionAddress(null);
        this.patchPayeeFromLocationForExistingTinNewLocation();
        this.setPayeeEditState(true);
        this.updateServiceLocationCheckboxState();
      } else {
        this.clearPayeeFieldsForExistingTinNewLocation();
        this.setPayeeEditState(false);
        this.updateServiceLocationCheckboxState();
      }
      return;
    }
    if (this.shouldPreserveLockedMergedTinValues()) {
      this.applyMergedEditTinFieldState(this.isTinFromDW);
      this.setPayeeEditState(isChecked, false);
      return;
    }
    if (isChecked) {
      if (this.locationFormGroupInput) {
        this.patchFormsFromLocationForm();
      } else if (this.latestlocation && this.latestlocation[0]) {
        this.patchFormsFromLatestLocation();
      } else {
        this.patchTinFromPayee();
      }
      this.enableTinForManualEdit();
      this.setPayeeEditState(true);
    } else {
      this.clearPayeeAndTinSections();
      this.enableTinForManualEdit();
    }
  }

  private initializeServiceLocationSync() {
    if (!this.locationFormGroupInput) {
      return;
    }

    this.updateServiceLocationCheckboxState();

    this.locationFormSyncSubscription = this.locationFormGroupInput.valueChanges.subscribe(() => {
      this.updateServiceLocationCheckboxState();
      const isServiceLocationChecked = !!this.serviceCheckForm.get('serviceLocationChecked')?.value;
      if (!isServiceLocationChecked) {
        return;
      }
      if (this.isExistingTinNewLocationFlow) {
        this.patchPayeeFromLocationForExistingTinNewLocation();
        return;
      }
      if (this.tinFormGroup.disabled) {
        return;
      }
      if (this.isDwMergedLocationEditMode) {
        return;
      }
      if (this.shouldPreserveLockedMergedTinValues()) {
        return;
      }
      this.patchFormsFromLocationForm();
    });
  }

  private updateServiceLocationCheckboxState() {
    const serviceLocationControl = this.serviceCheckForm.get('serviceLocationChecked');
    if (!serviceLocationControl || !this.locationFormGroupInput) {
      return;
    }

    if (this.isDwMergedLocationEditMode) {
      serviceLocationControl.disable({ emitEvent: false });
      this.syncExistingPayeeSelectionControlState();
      return;
    }
    if (this.isMergedLocationEditMode) {
      if (this.impersonatedUser) {
        serviceLocationControl.disable({ emitEvent: false });
      } else {
        serviceLocationControl.enable({ emitEvent: false });
      }
      if (this.isExistingTinNewLocationFlow && this.hasExistingPayeeSelection) {
        serviceLocationControl.disable({ emitEvent: false });
      }
      this.syncExistingPayeeSelectionControlState();
      return;
    }

    if (this.isExistingTinNewLocationFlow && this.hasExistingPayeeSelection) {
      serviceLocationControl.disable({ emitEvent: false });
      this.syncExistingPayeeSelectionControlState();
      return;
    }

    if (this.locationFormGroupInput.valid) {
      serviceLocationControl.enable({ emitEvent: false });
      this.syncExistingPayeeSelectionControlState();
      return;
    }

    serviceLocationControl.disable({ emitEvent: false });
    this.syncExistingPayeeSelectionControlState();
  }

  clearPayeeAndTinSections() {
    this.payeeFormGroup.patchValue({
      payeeLocation: '',
      payeeAddress2: '',
      payeeCity: '',
      payeeState: '',
      payeeZip: '',
      payeePhone: '',
      payeeEmail: '',
      npi2: '',
    });

    this.tinFormGroup.patchValue({
      location: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
    });
  }

  setPayeeEditState(isServiceLocationChecked: boolean, syncNameFieldsFromLocation: boolean = true) {
    if (isServiceLocationChecked) {
      this.payeeFormGroup.disable();
      this.payeeFormGroup.get('npi2')?.enable();
      return;
    }

    this.payeeFormGroup.enable();
    if (syncNameFieldsFromLocation) {
      this.enforceNameFieldsFromLocation();
      return;
    }
    this.payeeFormGroup.get('payeeName')?.disable();
    this.tinFormGroup.get('taxEntityName')?.disable();
  }

  initializeLocationNameBinding() {
    const locationNameControl = this.locationFormGroupInput?.get('name');
    if (locationNameControl) {
      this.enforceNameFieldsFromLocation(locationNameControl.value || '');
      locationNameControl.valueChanges.subscribe((value) => {
        this.enforceNameFieldsFromLocation(value || '');
      });
      return;
    }

    this.enforceNameFieldsFromLocation();
  }

  enforceNameFieldsFromLocation(locationName?: string) {
    const locationData: any = this.locationFormGroupInput?.getRawValue?.() || {};
    const resolvedLocationName =
      locationName ??
      this.getFirstNonEmpty(locationData, ['name']) ??
      this.latestlocation?.[0]?.name ??
      '';

    this.payeeFormGroup.patchValue(
      { payeeName: resolvedLocationName },
      { emitEvent: false }
    );
    this.tinFormGroup.patchValue(
      { taxEntityName: resolvedLocationName },
      { emitEvent: false }
    );

    this.payeeFormGroup.get('payeeName')?.disable();
    this.tinFormGroup.get('taxEntityName')?.disable();
  }

  private applyMergedEditTinFieldState(isDwTin: boolean) {
    const lockTinFieldsOnMergedEdit =
      !!this.locationMetaInput?.lockTinFieldsOnEdit ||
      isDwTin;
    if (lockTinFieldsOnMergedEdit) {
      this.tinFormGroup.disable();
      this.tinFormGroup.get('w9Control')?.enable();
      return;
    }

    this.tinFormGroup.enable();
    this.enforceNameFieldsFromLocation();
    this.tinFormGroup.get('taxId')?.disable();
    this.tinFormGroup.get('w9Control')?.enable();
  }

  buildDraftLocationPayloadFromParent(): any[] {
    const formData: any = this.locationFormGroupInput?.getRawValue?.() || {};
    if (!formData.tin || !formData.name || !formData.location || !formData.city || !formData.state || !formData.zip) {
      return [];
    }

    const eventId = localStorage.getItem('credentialingEventId');
    const loginUserId = localStorage.getItem('loggedUserId');

    const isPrimary = this.locationMetaInput?.isPrimary === 'yes' ? true : this.locationMetaInput?.isPrimary === 'no' ? false : null;
    const isParticipating = this.locationMetaInput?.isParticipating === 'yes' ? true : this.locationMetaInput?.isParticipating === 'no' ? false : null;
    const stillPracticing = this.locationMetaInput?.isPracticing === 'yes' ? true : this.locationMetaInput?.isPracticing === 'no' ? false : null;

    const payload = {
      locationId: null,
      name: formData.name,
      address: formData.location,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      tin: formData.tin,
      isPrimary: isPrimary,
      isLocationFromTINSearch: this.locationMetaInput?.isLocationFromTinSearch ? true : false,
      userId: loginUserId ? Number(loginUserId) : 0,
      credentialingEventId: eventId,
      stillPracticing: stillPracticing,
      startPracticingAt: formData.startDate ? this.formatDate(formData.startDate) : null,
      endedPracticingAt: formData.endDate ? this.formatDate(formData.endDate) : null,
      isParticipating: isParticipating,
      esLocationId: null,
      dcaDocumentId: this.locationMetaInput?.dcaDocumentId ?? null,
      officeTypeID: formData.officeTypeID || null,
      voicePhone: formData.voicePhone,
      email: formData.email
    };

    return [payload];
  }

  enableTinForManualEdit() {
    this.tinFormGroup.enable();
    this.payeeFormGroup.enable();

    if (this.isLocationEditMode && this.isMergedLocationEditMode) {
      this.applyMergedEditTinFieldState(this.isTinFromDW);
      return;
    }

    // Keep fields that are intentionally controlled/locked by flow rules.
    this.enforceNameFieldsFromLocation();
    if (localStorage.getItem('isnewTIN') && localStorage.getItem('isnewTIN') == 'true') {
      this.tinFormGroup.get('taxId')?.disable();
    }
  }

  patchTinFromPayee() {
    const payeeData: any = this.payeeFormGroup.getRawValue();
    this.patchTinAndPayeeForms({
      location: payeeData.payeeLocation || '',
      address2: payeeData.payeeAddress2 || '',
      city: payeeData.payeeCity || '',
      state: payeeData.payeeState || '',
      zip: payeeData.payeeZip || '',
      phone: payeeData.payeePhone || '',
      payeePhone: payeeData.payeePhone || '',
      payeeEmail: payeeData.payeeEmail || '',
    });
  }

  patchFormsFromLocationForm() {
    const locationData: any = this.locationFormGroupInput?.getRawValue() || {};
    const tinData: any = this.tinFormGroup.getRawValue();
    const payeeData: any = this.payeeFormGroup.getRawValue();
    const shouldUpdateTinFromLocation =
      !this.tinFormGroup.disabled &&
      !this.isExistingTinNewLocationFlow &&
      (
        !this.isLocationEditMode ||
        (this.isMergedLocationEditMode && !this.shouldPreserveLockedMergedTinValues())
      );

    const taxId = this.getFirstNonEmpty(locationData, ['tin']) || tinData.taxId;
    const name = this.getFirstNonEmpty(locationData, ['name']) || payeeData.payeeName || tinData.taxEntityName;
    const location = this.getFirstNonEmpty(locationData, ['location', 'address', 'address1']) || payeeData.payeeLocation || tinData.location;
    const city = this.getFirstNonEmpty(locationData, ['city']) || payeeData.payeeCity || tinData.city;
    const state = this.getFirstNonEmpty(locationData, ['state']) || payeeData.payeeState || tinData.state;
    const zip = this.getFirstNonEmpty(locationData, ['zip']) || payeeData.payeeZip || tinData.zip;
    const payeePhone = this.getFirstNonEmpty(locationData, ['voicePhone']) || payeeData.payeePhone;
    const payeeEmail = this.getFirstNonEmpty(locationData, ['email']) || payeeData.payeeEmail;

    this.patchTinAndPayeeForms({
      ...(shouldUpdateTinFromLocation ? {
        taxId: taxId,
        taxEntityName: name,
        location: location,
        city: city,
        state: state,
        zip: zip,
        phone: payeePhone,
      } : {}),
      payeeName: name,
      payeeLocation: location,
      payeeCity: city,
      payeeState: state,
      payeeZip: zip,
      payeePhone: payeePhone,
      payeeEmail: payeeEmail,
    });
  }

  patchTinAndPayeeForms(data: any) {
    const tinPatch: any = {};
    const payeePatch: any = {};

    if (data.taxId !== undefined) tinPatch.taxId = data.taxId;
    if (data.taxEntityName !== undefined) tinPatch.taxEntityName = data.taxEntityName;
    if (data.location !== undefined) tinPatch.location = data.location;
    if (data.address2 !== undefined) tinPatch.address2 = data.address2;
    if (data.city !== undefined) tinPatch.city = data.city;
    if (data.state !== undefined) tinPatch.state = data.state;
    if (data.zip !== undefined) tinPatch.zip = data.zip;
    if (data.phone !== undefined) tinPatch.phone = data.phone;
    if (data.effectiveDate !== undefined) tinPatch.effectiveDate = data.effectiveDate;

    if (data.payeeName !== undefined) payeePatch.payeeName = data.payeeName;
    if (data.payeeLocation !== undefined) payeePatch.payeeLocation = data.payeeLocation;
    if (data.payeeAddress2 !== undefined) payeePatch.payeeAddress2 = data.payeeAddress2;
    if (data.payeeCity !== undefined) payeePatch.payeeCity = data.payeeCity;
    if (data.payeeState !== undefined) payeePatch.payeeState = data.payeeState;
    if (data.payeeZip !== undefined) payeePatch.payeeZip = data.payeeZip;
    if (data.payeePhone !== undefined) payeePatch.payeePhone = data.payeePhone;
    if (data.payeeEmail !== undefined) payeePatch.payeeEmail = data.payeeEmail;
    if (data.npi2 !== undefined) payeePatch.npi2 = data.npi2;

    if (Object.keys(tinPatch).length > 0) {
      this.tinFormGroup.patchValue(tinPatch);
    }

    if (Object.keys(payeePatch).length > 0) {
      this.payeeFormGroup.patchValue(payeePatch);
    }
  }

  onBack() {
    if (localStorage.getItem('isW9Alert') && localStorage.getItem('isW9Alert') == 'true') {
      this.router.navigate(['credentialing/search-tin'])
      localStorage.removeItem('isW9Alert')
    }
    else if (localStorage.getItem('isnewTIN') == "true") {
      this.router.navigate(['/credentialing/locations/add']);
    }
    else {
      this.router.navigate(['/credentialing/locations']);
      localStorage.removeItem('isW9Alert')
    }
  }

  onCancel() {
    this.navigateToLocationsLanding();
  }

  onBlur(event: any) {
    const type = event.target.dataset.type;
    if (event?.target.value.length == 0) {
      if (type == 'tin') { this.showError = true }
      else if (type == 'payee') { this.showErrorPayee = true }
    }
  }
  onAddress1Change(val: any, type: any) {
    $('.pac-container').addClass('hide');
    if (val.length > 0) {
      if (type == 'tin') { this.showError = false
        this.showFulladdressError = false
       }
      else if (type == 'payee') { this.showErrorPayee = false
        this.showFulladdressErrorPayee = false
        this.showStateError = false
       }
    }
  }
  async onFocus() {
    $('.pac-container').addClass('hide');
    await this.repositionDropdown();
  }
  async repositionDropdown() {

    const input = this.locationInputs.get(0)?.nativeElement;
    const pacContainer = document.querySelector('.pac-container') as HTMLElement;

    if (pacContainer && input) {
      // Style positioning

      pacContainer.style.position = 'absolute';
      const rect = this.locationInputs.get(0)?.nativeElement.getBoundingClientRect();
      pacContainer.style.top = `${rect.bottom + window.scrollY}px`;
      pacContainer.style.left = `${rect.left}px`;
      pacContainer.style.width = `${rect.width}px`;
    }

  }

  async onScroll() {
    $('.pac-container').addClass('hide');
  }
  async ngAfterViewInit() {
    if ((window as any).google) {
      await this.initializeAutoComplete();
    }
    else {
      const interval = setInterval(async () => {
        if ((window as any).google) {
          clearInterval(interval);
          await this.initializeAutoComplete();
        }
      }, 300)
    }
    this.locationInputs.changes.subscribe(async () => {
      $('.pac-container').addClass('hide');
      await this.initializeAutoComplete();
    })
    const input = document.querySelector(
      'app-file-text-upload input'
    ) as HTMLInputElement;

    if (input) {
      input.disabled = true;
      input.placeholder = 'W9 Document';
    }
  }
  async initializeAutoComplete() {
    const visibleInputs = this.locationInputs.filter(
      (inputRef: ElementRef) =>
        !!inputRef.nativeElement.offsetParent
    )
    visibleInputs.forEach((inputRef) => {
      const fieldType = inputRef.nativeElement.dataset.type;
      const autoComplete = new (window as any).google.maps.places.Autocomplete(
        inputRef.nativeElement, {
        types: ['address'],
        componentRestrictions: { country: 'us' }
      }
      );

      const autoCompleteService = new google.maps.places.AutocompleteService()

      autoComplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place = autoComplete.getPlace();
          if (place && place.formatted_address) {
            if (fieldType == 'tin') {
              this.showError = false
              this.showStateError = false;
            }
            else if (fieldType == 'payee') {
              this.showErrorPayee = false
            }
            this.selectedAddress = place.formatted_address || '';
            this.isPlaceSelected = true;
            let homeAddress = '';
            let city = '';
            let state = '';
            let zip = '';
            let streetNumber = '';
            let route = '';
            place.address_components?.forEach((component: any) => {

              // Street Number
              if (component.types.includes('street_number')) {
                streetNumber = component.long_name;
              }

              // Street Name
              if (component.types.includes('route')) {
                route = component.long_name;
              }
              // City
              if (!city && component.types.includes('locality')) {
                city = component.long_name;
              }
              else if (!city && component.types.includes('postal_town')) {
                city = component.long_name;
              }
              else if (!city && component.types.includes('sublocality')) {
                city = component.long_name;
              }
              else if (!city && component.types.includes('administrative_area_level_2')) {
                city = component.long_name;
              }
              // State
              if (component.types.includes('administrative_area_level_1')) {
                state = component.short_name;
              }

              // ZIP
              if (component.types.includes('postal_code')) {
                zip = component.long_name;
              }
            });
            // Build address line
            homeAddress = `${streetNumber} ${route}`.trim();
            if (fieldType == 'tin') {
              this.tinFormGroup.patchValue(({
                "location": homeAddress
              }))
              this.tinFormGroup.patchValue(({
                "city": city
              }))
              this.tinFormGroup.patchValue(({
                "state": state
              }))
              this.tinFormGroup.patchValue(({
                "zip": zip
              }))
              if (!zip) {
                this.showFulladdressError = true
              } else {
                this.showFulladdressError = false
              }

            } else if (fieldType == 'payee') {
              this.payeeFormGroup.patchValue(({
                "payeeLocation": homeAddress
              }))
              this.payeeFormGroup.patchValue(({
                "payeeCity": city
              }))
              this.payeeFormGroup.patchValue(({
                "payeeState": state
              }))
              this.payeeFormGroup.patchValue(({
                "payeeZip": zip
              }))
              if (!zip) {
                this.showFulladdressErrorPayee = true
              } else {
                this.showFulladdressErrorPayee = false
              }
            }
            this.validateLocation(this.selectedAddress);
          }
        })
      })

      inputRef.nativeElement.addEventListener('input', (e: any) => {
        this.isPlaceSelected = false;
        const value = e.target.value;

        if (!value) {
          this.suggestionCount = 0;
          return;
        }
        autoCompleteService.getPlacePredictions(
          {
            input: value, types: ['address'],
            componentRestrictions: { country: 'us' }
          },
          (predictions, status) => {
            this.ngZone.run(async () => {
              if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
                await this.repositionDropdown();
                $('.pac-container').removeClass('hide');
                this.suggestionCount = predictions.length;
              }
              else {
                this.suggestionCount = 0;
              }
            })
          }
        )
      })
      const input = inputRef.nativeElement;
      if (fieldType == 'tin') { input.setAttribute('placeholder', 'Type tax entity address') }
      else if (fieldType == 'payee') { input.setAttribute('placeholder', 'Type payee address') }

    })

    window.addEventListener('scroll', this.scrollHandler, true);
    window.addEventListener('touchmove', this.scrollHandler, true);

  }
  ngOnDestroy() {
    this.locationFormSyncSubscription?.unsubscribe();
    localStorage.removeItem('isCorpAuthDeleteRequired');
    localStorage.removeItem('isPADocDeleteRequired');
    localStorage.removeItem('editTinData')
    localStorage.removeItem('isW9Alert')
    localStorage.removeItem('LocationSavePayload')
    sessionStorage.removeItem('selectedLocationRecord');
    window.removeEventListener('scroll', this.scrollHandler, true);
    window.removeEventListener('touchmove', this.scrollHandler, true);
  }
  validateLocation(inputText: string): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.isPlaceSelected && (!inputText || inputText.trim().length < 3)) {
        resolve(false);
        return;
      }
      if (!this.isPlaceSelected && (!inputText || inputText.trim().length == 3)) {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: inputText }, (results: any, status: any) => {
          if (status === google.maps.GeocoderStatus.OK) {
            const valid = results.some((r: any) =>
              r.types.includes('locality') || r.types.includes('administrative_area_level_1') || r.types.includes('country')
            )
            resolve(valid);
          }
          else {
            resolve(false);
          }
        })
        return;
      }
      const service = new google.maps.places.AutocompleteService();
      service.getPlacePredictions({ input: inputText }, (predictions: any, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length > 0) {
          resolve(true);
          return;
        }
        else {
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address: inputText }, (results: any, status: any) => {
            if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
              resolve(true);
            }
            else {
              resolve(false);
            }
          })
        }
      })

    })
  }

  triggerFileSelect() {
    this.w9Upload?.triggerFileSelect();
  }

  async onUploadDocument(event: any) {
    this.loaderService.show();

    let file: File;
    let type = 'W9';

    if (event?.file) {
      file = event.file;
      type = event.type || 'W9';
    }
    else {
      const input = event.target as HTMLInputElement;
      if (!input?.files || !input.files.length) return;
      file = input.files[0];
    }

    const credentialPayload = JSON.parse(localStorage.getItem('getCredentialpayload')!);
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const uniqueId = uuidv4();
    const ext = file.name.split('.').pop();

    if (!ext?.includes('pdf')) {
      this.dialog.open(PopupComponent, {
        disableClose: true,
        data: { headerMessage: 'Alert', message: 'Only PDF is accepted.', isPTESaved: true },
        width: '550px',
        backdropClass: '',
        hasBackdrop: true,
      });
      this.loaderService.hide();
      return;
    }

    const filename = `${year}${month}${day}_${credentialPayload['npi']}_${uniqueId}`;

    try {
      const subCategoryId = DocumentSubCategory.W9Form;
      const response: any = await this.uploadDocument(file, filename, subCategoryId);
      this.w9DocumentId = response.documentId;
      this.W9fileName = filename;
      this.showDocError = false;
      this.showW9Asterisk = false;

      this.w9Documents = [{
        originalFileName: `${filename}.pdf`,
        name: `W9.pdf`
      }];

      this.loaderService.hide();
    } catch (error) {
      try {
        this.sharedService.logError("APIFailed", "FileDental-Location - saveDocument, Method:onUploadDocument", this.router.url.split('?')[0], error).subscribe();
      } catch (e) { }
      this.loaderService.hide();
    }
  }

  async uploadDocument(file: any, filename: any, subCategoryId: any) {

    const loginUserId = localStorage.getItem("loggedUserId");

    const params = {
      "credentialingEventId": localStorage.getItem('credentialingEventId'),
      "categoryId": DocumentCategory.Location,
      "subCategoryId": subCategoryId,
      "fileName": filename,
      "isSigned": true,
      "userId": loginUserId || -1
    }

    const response = await this.dentalCredentialingService.saveDocument(file, params);
    // Get existing documents from localStorage
    const documents = this.getStorageArray('documents');

    // Append new document
    documents.push({
      credentialingEventId: localStorage.getItem('credentialingEventId'),
      categoryId: DocumentCategory.Location,
      category: "Location",
      subCategoryId: subCategoryId,
      subcategory: DocumentSubCategoryName[subCategoryId],
      fileName: filename,
      isSigned: true,
      userId: loginUserId || -1,
      documentId: response.documentId
    });
    const TINDetails: any[] = this.getStorageArray('TINDetails');
    const editTinData: any = JSON.parse(localStorage.getItem('editTinData') || '{}');

    const tinIndex = TINDetails.findIndex((x: any) =>
      this.isSameTinIdentifier(x?.taxId ?? x?.tin, editTinData?.taxId ?? editTinData?.tin)
    );
    if (tinIndex !== -1) {
      TINDetails.splice(tinIndex, 1);
    }
    editTinData.w9DocumentID = response.documentId;
    TINDetails.push(editTinData);
    localStorage.setItem('TINDetails', JSON.stringify(TINDetails));
    // Save back to localStorage
    localStorage.setItem('documents', JSON.stringify(documents));

    return response;

  }
  

  async deleteW9Document(noHide?:boolean): Promise<boolean> {
    this.loaderService.show();
    const loginUserId = localStorage.getItem("loggedUserId");
    const credentialingEventId = localStorage.getItem('credentialingEventId');
    const documents = this.getStorageArray('documents');
    const matchingW9Document = documents.find((item: any) =>
      item.subCategoryId === DocumentSubCategory.W9Form &&
      (!this.w9DocumentId || `${item.documentId}` === `${this.w9DocumentId}`)
    );
    const filename = this.W9fileName || matchingW9Document?.fileName || '';
    if (!filename) {
      if(!noHide){
        this.loaderService.hide();
      }
      return false;
    }
    const requestParams = {
      "credentialingEventID": Number(credentialingEventId),
      "fileName": filename,
      "modifiedUserID": loginUserId ? Number(loginUserId) : -1
    }
    return new Promise((resolve) => {
      this.dentalCredentialingService.deleteDocument(requestParams).subscribe({
        next: () => {
          this.w9DocumentId = null;
          this.W9fileName = '';
          this.w9Documents = [];
          this.showW9Asterisk = true;
          const updatedDocuments = this.getStorageArray('documents');
          const index = updatedDocuments.findIndex(
            (item: any) => item.subCategoryId === DocumentSubCategory.W9Form && item.fileName === filename
          );

          if (index !== -1) {
            updatedDocuments.splice(index, 1);
          }
          localStorage.setItem('documents', JSON.stringify(updatedDocuments));
          const TINDetails = this.getStorageArray('TINDetails');
          const editTinData = JSON.parse(localStorage.getItem('editTinData') || '{}');
          const tinIndex = TINDetails.findIndex((x: any) =>
            this.isSameTinIdentifier(x?.taxId ?? x?.tin, editTinData?.taxId ?? editTinData?.tin)
          );
          if (tinIndex !== -1) {
            TINDetails.splice(tinIndex, 1);
          }
          editTinData.w9DocumentID = null;
          TINDetails.push(editTinData);
          localStorage.setItem('TINDetails', JSON.stringify(TINDetails));
          if(!noHide){
            this.loaderService.hide();
          }
          resolve(true);
        }, error: (err: any) => {
          this.sharedService.logError("APIFailed", "FileSigned-documentsComponent - deleteDocument, Method:onDeleteDocument", this.router.url.split('?')[0], err).subscribe();
          if(!noHide){
            this.loaderService.hide();
          }
          resolve(false);
        }
      });
    });
  }
  async onDeleteW9Document(index?: number) {
    await this.deleteW9Document();
  }

  private hasInvalidTinOrPayeeSaveState(markAsTouched: boolean): boolean {
    if (markAsTouched) {
      this.tinFormGroup.markAllAsTouched();
      this.payeeFormGroup.markAllAsTouched();
    }

    const hasInvalidEnabledTinControl = Object.keys(this.tinFormGroup.controls).some((key) => {
      const control = this.tinFormGroup.get(key);
      return !!control && control.enabled && control.invalid;
    });
    const hasInvalidEnabledPayeeControl = Object.keys(this.payeeFormGroup.controls).some((key) => {
      const control = this.payeeFormGroup.get(key);
      return !!control && control.enabled && control.invalid;
    });

    return hasInvalidEnabledTinControl || hasInvalidEnabledPayeeControl;
  }

  private hasInvalidParentLocationSaveState(markAsTouched: boolean): boolean {
    if (!this.locationFormGroupInput) {
      return false;
    }

    if (markAsTouched) {
      this.locationFormGroupInput.markAllAsTouched();
    }

    return Object.keys(this.locationFormGroupInput.controls).some((key) => {
      const control = this.locationFormGroupInput?.get(key);
      return !!control && control.enabled && control.invalid;
    });
  }

  onSave() {
    if (this.hasInvalidParentLocationSaveState(true) || this.hasInvalidTinOrPayeeSaveState(true)) {
      if (this.isW9Required && !this.w9DocumentId) {
        this.showDocError = true;
      }
      return;
    }
    if (this.isW9Required && !this.w9DocumentId) {
      this.showDocError = true;
      return
    }
    if (this.shouldDeleteW9OnSave && this.w9DocumentId) {
      this.onDeleteW9Document();
    }
    let tinFormData: any = this.tinFormGroup.getRawValue();
    let payeeFormData: any = this.payeeFormGroup.getRawValue();
    let eventId = localStorage.getItem('credentialingEventId')
    const credentialingEventId = eventId ? Number(eventId) : 0;
    const loginUserId = localStorage.getItem("loggedUserId");
    const resolvedUserId = loginUserId ? Number(loginUserId) : -1;

    const esPayeeId = (this.isW9Alert || this.isEditMode) ? this.payeeID : null;

    this.loaderService.show();
    const tinData = JSON.parse(localStorage.getItem('editTinData') || "{}");

    if (!tinData.IsTinFromDW) {
      tinData.IsTinFromDW = false;
    }
    const savedTinRecord = (JSON.parse(localStorage.getItem('TINDetails') || '[]') || [])
      .find((item: any) => this.isSameTinIdentifier(item?.taxId ?? item?.tin, tinFormData.taxId));
    const isTinFromDW = this.isDwTinFlag(tinData) || this.isDwTinFlag(savedTinRecord) || this.isDwTinFlag(this.TINdata);
    // Existing-TIN-new-location flow saves the location first and records its id here.
    const resolvedLocationId =
      this.locationMetaInput?.locationId ??
      (Number(localStorage.getItem('latestCreatedLocationId')) || null);
    const persistableW9DocumentId = this.shouldDeleteW9OnSave
      ? null
      : this.resolvePersistableW9DocumentId();

    const payload: any = {
      "taxTypeId": tinFormData.taxIdType ? Number(tinFormData.taxIdType) : 0,
      "taxId": tinFormData.taxId,
      "taxEntityName": tinFormData.taxEntityName,
      "taxEntityAddress1": tinFormData.location,
      "taxEntityAddress2": tinFormData.address2,
      "taxEntityCity": tinFormData.city,
      "taxEntityState": tinFormData.state,
      "taxEntityZip": tinFormData.zip,
      "taxEntityVoicePhone": tinFormData.phone,
      "effectiveDate": tinFormData.effectiveDate ? this.formatDate(tinFormData.effectiveDate) : null,
      "esPayeeId": esPayeeId,
      "isTinFromDW": isTinFromDW,
      "locationId": resolvedLocationId,
      "payeeName": payeeFormData.payeeName,
      "payeeAddressLine1": payeeFormData.payeeLocation,
      "payeeAddressLine2": payeeFormData.payeeAddress2,
      "payeeCity": payeeFormData.payeeCity,
      "payeeState": payeeFormData.payeeState,
      "payeeZip": payeeFormData.payeeZip,
      "payeeVoicePhone": payeeFormData.payeePhone,
      "payeeEmail": payeeFormData.payeeEmail,
      "payeeNPI": payeeFormData.npi2,
      "w9DocumentID": persistableW9DocumentId,
      "serviceLocationSameAsPayee": this.serviceCheckForm.get('serviceLocationChecked')?.value,
      "activeFlg": true,
      "userId": resolvedUserId,
      "credentialingEventId": credentialingEventId
    }
    const tinDetails = JSON.parse(localStorage.getItem('TINDetails') || '[]');
    const matchingTin = tinDetails.find((x: any) => this.isSameTinIdentifier(x?.taxId ?? x?.tin, tinFormData.taxId));
    const resolvedTaxEntityId =
      this.TINdata?.taxEntityId ??
      this.editTinData?.taxEntityId ??
      matchingTin?.taxEntityId ??
      null;

    if (resolvedTaxEntityId) {
      payload['taxEntityId'] = Number(resolvedTaxEntityId);
    }
    if (this.isW9Alert && ((this.TINdata && this.TINdata?.taxTypeId == 0 || this.TINdata?.taxTypeId == -1))) {
      payload.taxTypeId = this.TINdata.taxTypeId;
    }
    const isNewTinFlow = localStorage.getItem('isnewTIN') === 'true';
    const storedDraft = isNewTinFlow ? JSON.parse(localStorage.getItem('LocationSavePayload') || '[]') : [];
    const draftLocationRecords = isNewTinFlow
      ? ((Array.isArray(storedDraft) && storedDraft.length > 0)
        ? storedDraft
        : this.buildDraftLocationPayloadFromParent())
      : [];
    const saveLocationRecords = draftLocationRecords.map((location: any) => {
      if (location?.locationId == null) {
        const { serviceLocationChecked, ...locationPayload } = location;
        return locationPayload;
      }
      return location;
    });
    const wrapperLocationRecords = this.buildWrapperLocationRecords(
      saveLocationRecords,
      credentialingEventId,
      resolvedUserId
    );
    const wrapperTaxEntityPayload = this.buildWrapperTaxEntityPayload(
      payload,
      credentialingEventId,
      resolvedUserId
    );
    const wrapperPayload = !this.isW9Alert && isNewTinFlow
      ? {
        locations: wrapperLocationRecords,
        taxEntities: wrapperTaxEntityPayload
      }
      : {
        taxEntities: wrapperTaxEntityPayload
      };

    this.sharedService.saveLocationPayeeTax(wrapperPayload).subscribe({
      next: (response: any) => {
        try {
          this.isSaved = true
          if (!this.isEditMode && payload?.taxId) {
            localStorage.setItem('latestCreatedTinTaxId', String(payload.taxId));
          }
          if (payload['serviceLocationSameAsPayee']) {
            const locationPayload = payload
            localStorage.setItem('locationValueFromTINSave', JSON.stringify(locationPayload))
          }
          if (!this.isEditMode) {
            localStorage.setItem('TINValueFromTINSave', payload['taxId']);
          }

          const updatedTinDetails = JSON.parse(localStorage.getItem('TINDetails') || '[]');
          const returnedTaxEntityId =
            response?.taxEntities?.taxEntityId ??
            response?.taxEntityId ??
            response?.data?.taxEntityId ??
            payload?.taxEntityId;
          const updatedRecord = {
            ...payload,
            ...(returnedTaxEntityId ? { taxEntityId: Number(returnedTaxEntityId) } : {})
          };
          const nextTinDetails = this.upsertTinDetailRecord(updatedTinDetails, updatedRecord, payload);
          localStorage.setItem('TINDetails', JSON.stringify(nextTinDetails));
          const isExistingTinNewLocationFlowActive =
            this.isExistingTinNewLocationFlow || !!this.locationMetaInput?.isExistingTinNewLocationFlow;
          if (isExistingTinNewLocationFlowActive) {
            this.ensureExistingTinNewLocationCached(payload);
          }

          const isCorpAuthRequired = this.locationMetaInput?.isCorpAuthRequired !== undefined
            ? this.locationMetaInput.isCorpAuthRequired
            : (this.locationMetaInput?.isParticipating ? this.locationMetaInput.isParticipating === 'yes' : true);
          const isCorpAuthDeleteRequired = localStorage.getItem('isCorpAuthDeleteRequired') === 'true';
          const skipCorpAuthFlow = !isCorpAuthRequired || (isExistingTinNewLocationFlowActive && !this.isLocationEditMode);
          const documents = JSON.parse(localStorage.getItem('documents') || '[]');
          const activeLocationId =
            this.locationMetaInput?.locationId ??
            this.locationMetaInput?.esLocationId ??
            this.locationMetaInput?.locationLookupId ??
            localStorage.getItem('editLocationId');
          const storedLocations = JSON.parse(localStorage.getItem('locations') || '[]');
          const activeLocation = Array.isArray(storedLocations)
            ? storedLocations.find((location: any) =>
              (activeLocationId != null && `${location?.locationId ?? ''}` === `${activeLocationId}`) ||
              (activeLocationId != null && `${location?.esLocationId ?? ''}` === `${activeLocationId}`)
            )
            : null;
          const expectedDocumentId =
            this.locationMetaInput?.dcaDocumentId ??
            this.locationMetaInput?.dcaDocumentID ??
            activeLocation?.dcaDocumentId ??
            activeLocation?.dcaDocumentID ??
            null;
          const canDeleteExistingCorpAuth = this.isLocationEditMode || isCorpAuthDeleteRequired;
          const matchedCorpAuthDoc = expectedDocumentId == null
            ? null
            : (documents.find((d: any) =>
              d.categoryId == DocumentCategory.Location &&
              d.subCategoryId == DocumentSubCategory.CorporateAuthorityForm &&
              d.isSigned === true &&
              `${d.documentId}` === `${expectedDocumentId}`
            ) || null);
          const hasSignedCorpAuthDocument = !!matchedCorpAuthDoc;
          const corpAuthSignedData = this.locationMetaInput?.corpAuthSignedData;
          const hasCorpAuthSignedData = !!corpAuthSignedData && Object.keys(corpAuthSignedData).length > 0;
          const isPayeeAddressUpdated = (skipCorpAuthFlow || this.isReadOnlyTinSearchFlow)
            ? false
            : hasCorpAuthSignedData
              ? this.ValdiatePayeeAddress(corpAuthSignedData, payload)
              : (hasSignedCorpAuthDocument ? this.ValdiatePayeeAddress(this.beforeFormData, payload) : false);
          const shouldDeleteExistingCorpAuth = isCorpAuthDeleteRequired && canDeleteExistingCorpAuth;
          const shouldShowCorpAuthAlert = shouldDeleteExistingCorpAuth || (!skipCorpAuthFlow && hasSignedCorpAuthDocument && isPayeeAddressUpdated);
          if (shouldShowCorpAuthAlert) {
            const doc = matchedCorpAuthDoc;
            const filename = doc ? doc.fileName : '';
            this.clearLocalCorpAuthState(doc?.documentId, filename);
            if (filename) {
              this.deleteDocument(filename, DocumentSubCategory.CorporateAuthorityForm, doc?.documentId);
            }
            const alertMessage = `Please read and sign the corporate authority.`;
            const dialogRef = this.dialog.open(PopupComponent, {
              disableClose: true,
              data: { headerMessage: 'Alert', message: alertMessage, isPTESaved: true },
              width: '550px',
              backdropClass: '',
              hasBackdrop: true,
            });
            dialogRef.afterClosed().subscribe((result: any) => {
              if (result === true) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            });
          }
          if (skipCorpAuthFlow || shouldDeleteExistingCorpAuth) {
            localStorage.removeItem('isCorpAuthDeleteRequired');
          }

          let locationId;
          if (!this.isW9Alert && isNewTinFlow) {
            let newlocation: any
            const storedLocations = localStorage.getItem('locations');
            let locations = storedLocations ? JSON.parse(storedLocations) : [];
            const savedLocations = this.getSavedLocationRecords(response);
            if (saveLocationRecords && saveLocationRecords.length > 0) {
              saveLocationRecords.forEach((location: any) => {
                if (location.locationId == null) {
                  newlocation = location
                }
              })
              if (newlocation && newlocation.isPrimary) {
                locations.forEach((location: any) => {
                  if (location.isPrimary) {
                    location.isPrimary = false
                  }
                })
              }
              let existingIds = new Set<number>();
              existingIds = new Set(
                locations
                  .map((l: any) => l.locationId)
                  .filter((id: any) => id != null)
                  .map((id: any) => Number(id))
              );

              if (newlocation) {
                locations = [...locations, {
                  ...newlocation,
                  effectiveDate: payload.effectiveDate ?? newlocation.effectiveDate ?? null
                }];
              }

              const newLocFromApi = savedLocations.find(
                (loc: any) => !existingIds.has(Number(loc.locationId))
              );
              locationId = newLocFromApi ? newLocFromApi.locationId : null;
              if (newLocFromApi) {
                localStorage.setItem('latestCreatedLocationId', String(newLocFromApi.locationId));
                locations = locations.map((l: any) =>
                  l.locationId == null
                    ? {
                      ...l, locationId: newLocFromApi.locationId,
                      modifiedDate: newLocFromApi.modifiedDate,
                      createdDate: newLocFromApi.createdDate
                    }
                    : l
                );
              }
            }
            localStorage.setItem('locations', JSON.stringify(locations))
            const shouldPersistDirectoryInfo = this.shouldPersistDirectoryInfo(saveLocationRecords);
            if (shouldPersistDirectoryInfo) {
              const directoryLocationId = this.resolveDirectoryLocationId(locationId, savedLocations, saveLocationRecords);
              if (directoryLocationId !== null) {
                this.callDocAndDirectoryqns(directoryLocationId, eventId)
              } else {
                const error = new Error('Unable to resolve location id for directory save in new TIN flow.');
                this.sharedService.logError("APIFailed", "FileAddLocationComponent - saveDirectory, Method:onSave", this.router.url.split('?')[0], error).subscribe();
              }
            }
            this.loaderService.hide();
            localStorage.removeItem('isnewTIN')
            this.completeAndNavigateToLocationsLanding();
          } else if (this.isW9Alert) {
            this.loaderService.hide();
            localStorage.removeItem('isW9Alert')
            this.completeAndNavigateToLocationsLanding();
          } else if (this.isEditMode) {
            this.loaderService.hide();
            this.completeAndNavigateToLocationsLanding();
          } else {
            this.loaderService.hide();
            this.completeAndNavigateToLocationsLanding();
          }
        } catch (processingError: any) {
          this.loaderService.hide();
          this.sharedService.logError("APIFailed", "add-tinComponent - postSaveProcessing, Method:onSave", this.router.url.split('?')[0], processingError).subscribe();
          this.sharedService.deleteLocationFailedPopupCall(false, 'saveTin');
        }
      },
      error: (err: any) => {
        this.loaderService.hide();
        if (err && err.status == 409 && err.error?.message == "TIN already exists") {
          this.TINExistsAlertPopupCall(false).subscribe()
        } else {
          const validationMessage = this.resolveTinSaveValidationMessage(err);
          if (validationMessage) {
            this.dialog.open(PopupComponent, {
              disableClose: true,
              data: { headerMessage: 'Alert', message: validationMessage, isPTESaved: true },
              width: '550px',
              backdropClass: '',
              hasBackdrop: true,
            });
          } else {
            this.sharedService.deleteLocationFailedPopupCall(false, 'saveTin')
          }
        }
        this.sharedService.logError("APIFailed", "add-tinComponent - saveLocationPayeeTax, Method:onSave", this.router.url.split('?')[0], err).subscribe();
      }
    });

  }

  private resolveTinSaveValidationMessage(err: any): string | null {
    const taxEntityMessage = err?.error?.taxEntities?.message;
    if (typeof taxEntityMessage === 'string' && taxEntityMessage.trim() !== '') {
      return taxEntityMessage.trim();
    }

    if (err?.status === 422) {
      const responseMessage = err?.error?.message;
      if (typeof responseMessage === 'string' && responseMessage.trim() !== '') {
        return responseMessage.trim();
      }
    }

    return null;
  }

  private getSavedLocationRecords(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }

    const collections = [
      response?.locations,
      response?.saveLocationResponse,
      response?.locationResponse,
      response?.data?.locations,
      response?.data?.saveLocationResponse,
      response?.data?.locationResponse
    ];

    for (const collection of collections) {
      if (Array.isArray(collection)) {
        return collection;
      }
    }

    if (response?.locationId != null) {
      return [response];
    }
    if (response?.data?.locationId != null) {
      return [response.data];
    }

    return [];
  }

  private ensureExistingTinNewLocationCached(tinPayload: any): void {
    if (!this.locationFormGroupInput) {
      return;
    }

    const locationFormData: any = this.locationFormGroupInput.getRawValue?.() || {};
    const tin = this.getFirstNonEmpty(locationFormData, ['tin']) || tinPayload?.taxId || tinPayload?.tin || '';
    const name = this.getFirstNonEmpty(locationFormData, ['name']) || tinPayload?.taxEntityName || tinPayload?.payeeName || '';
    const address = this.getFirstNonEmpty(locationFormData, ['location', 'address', 'address1']) || tinPayload?.taxEntityAddress1 || tinPayload?.payeeAddressLine1 || '';
    const city = this.getFirstNonEmpty(locationFormData, ['city']) || tinPayload?.taxEntityCity || tinPayload?.payeeCity || '';
    const state = this.getFirstNonEmpty(locationFormData, ['state']) || tinPayload?.taxEntityState || tinPayload?.payeeState || '';
    const zip = this.getFirstNonEmpty(locationFormData, ['zip']) || tinPayload?.taxEntityZip || tinPayload?.payeeZip || '';

    if (!tin || !name || !address || !city || !state || !zip) {
      return;
    }

    const storedLocations = localStorage.getItem('locations');
    const parsedLocations = storedLocations ? JSON.parse(storedLocations) : [];
    const locations = Array.isArray(parsedLocations) ? parsedLocations : [];
    const normalize = (value: any): string => `${value ?? ''}`.trim().toLowerCase();
    const targetKey = [tin, address, city, state, zip].map((value: any) => normalize(value)).join('|');
    const locationLookupIds = this.getLocationLookupIds(locationFormData);
    const lookupIdSet = new Set(locationLookupIds);
    const existingLocationIndex = locations.findIndex((location: any) => {
      const candidateIds = [location?.locationId, location?.esLocationId]
        .filter((id: any) => id !== undefined && id !== null && `${id}` !== '')
        .map((id: any) => `${id}`);
      if (candidateIds.some((id: string) => lookupIdSet.has(id))) {
        return true;
      }
      const locationKey = [
        this.getFirstNonEmpty(location, ['tin', 'taxId']),
        this.getFirstNonEmpty(location, ['address1', 'address', 'location']),
        this.getFirstNonEmpty(location, ['city']),
        this.getFirstNonEmpty(location, ['state']),
        this.getFirstNonEmpty(location, ['zip'])
      ].map((value: any) => normalize(value)).join('|');
      return locationKey === targetKey;
    });

    const existingLocation = existingLocationIndex !== -1 ? locations[existingLocationIndex] : {};
    const createdLocationId = Number(localStorage.getItem('latestCreatedLocationId'));
    const fallbackCreatedLocationId = (existingLocationIndex === -1 && !Number.isNaN(createdLocationId) && createdLocationId > 0)
      ? createdLocationId
      : null;
    const resolvedLocationId =
      existingLocation?.locationId ??
      this.locationMetaInput?.locationId ??
      locationFormData?.locationId ??
      fallbackCreatedLocationId;
    const isPrimary = this.locationMetaInput?.isPrimary === 'yes' ? true : this.locationMetaInput?.isPrimary === 'no' ? false : existingLocation?.isPrimary ?? null;
    const isParticipating = this.locationMetaInput?.isParticipating === 'yes' ? true : this.locationMetaInput?.isParticipating === 'no' ? false : existingLocation?.isParticipating ?? null;
    const stillPracticing = this.locationMetaInput?.isPracticing === 'yes' ? true : this.locationMetaInput?.isPracticing === 'no' ? false : existingLocation?.stillPracticing ?? null;

    const normalizedLocationRecord = {
      ...existingLocation,
      ...(resolvedLocationId == null ? {} : { locationId: resolvedLocationId }),
      name,
      address1: address,
      address,
      city,
      state,
      zip,
      tin,
      isPrimary,
      isParticipating,
      stillPracticing,
      effectiveDate: tinPayload?.effectiveDate ?? existingLocation?.effectiveDate ?? null,
      isLocationFromTINSearch: !!this.locationMetaInput?.isLocationFromTinSearch,
      voicePhone: this.getFirstNonEmpty(locationFormData, ['voicePhone']) || tinPayload?.taxEntityVoicePhone || tinPayload?.payeeVoicePhone || existingLocation?.voicePhone || '',
      email: this.getFirstNonEmpty(locationFormData, ['email']) || tinPayload?.taxEntityEmail || tinPayload?.payeeEmail || existingLocation?.email || '',
      officeTypeID: this.getFirstNonEmpty(locationFormData, ['officeTypeID']) ?? existingLocation?.officeTypeID ?? null,
      dcaDocumentId: this.locationMetaInput?.dcaDocumentId ?? existingLocation?.dcaDocumentId ?? null,
      esLocationId: this.locationMetaInput?.esLocationId ?? existingLocation?.esLocationId ?? null
    };

    if (existingLocationIndex === -1) {
      locations.push(normalizedLocationRecord);
    } else {
      locations[existingLocationIndex] = normalizedLocationRecord;
    }

    localStorage.setItem('locations', JSON.stringify(locations));
  }

  private buildWrapperLocationRecords(
    locations: any[],
    credentialingEventId: number,
    userId: number
  ): any[] {
    return locations.map((location: any) => ({
      locationId: location?.locationId == null ? null : Number(location.locationId),
      credentialingEventId: Number(location?.credentialingEventId ?? credentialingEventId),
      name: location?.name ?? '',
      address: location?.address ?? location?.location ?? '',
      city: location?.city ?? '',
      state: location?.state ?? '',
      zip: location?.zip ?? '',
      tin: location?.tin ?? '',
      voicePhone: location?.voicePhone ?? '',
      isPrimary: !!location?.isPrimary,
      stillPracticing: location?.stillPracticing ?? null,
      endedPracticingAt: location?.endedPracticingAt ?? null,
      startPracticingAt: location?.startPracticingAt ?? null,
      isParticipating: location?.isParticipating ?? null,
      esLocationId: location?.esLocationId == null ? null : Number(location.esLocationId),
      dcaDocumentId: location?.dcaDocumentId == null ? null : Number(location.dcaDocumentId),
      userId: Number(location?.userId ?? userId),
      activeFlg: location?.activeFlg == null ? 1 : Number(location.activeFlg),
      officeTypeID: location?.officeTypeID == null ? null : Number(location.officeTypeID),
      isLocationFromTINSearch: !!location?.isLocationFromTINSearch,
      email: location?.email ?? ''
    }));
  }

  private buildWrapperTaxEntityPayload(
    taxEntity: any,
    credentialingEventId: number,
    userId: number
  ): any {
    return {
      taxEntityId: taxEntity?.taxEntityId == null ? null : Number(taxEntity.taxEntityId),
      taxTypeId: Number(taxEntity?.taxTypeId ?? 0),
      taxId: taxEntity?.taxId ?? '',
      credentialingEventId: Number(taxEntity?.credentialingEventId ?? credentialingEventId),
      taxEntityName: taxEntity?.taxEntityName ?? '',
      taxEntityAddress1: taxEntity?.taxEntityAddress1 ?? '',
      taxEntityAddress2: taxEntity?.taxEntityAddress2 ?? '',
      taxEntityCity: taxEntity?.taxEntityCity ?? '',
      taxEntityState: taxEntity?.taxEntityState ?? '',
      taxEntityZip: taxEntity?.taxEntityZip ?? '',
      taxEntityEmail: taxEntity?.taxEntityEmail ?? taxEntity?.payeeEmail ?? '',
      taxEntityVoicePhone: taxEntity?.taxEntityVoicePhone ?? '',
      effectiveDate: taxEntity?.effectiveDate ?? null,
      esPayeeId: taxEntity?.esPayeeId == null ? null : Number(taxEntity.esPayeeId),
      payeeName: taxEntity?.payeeName ?? '',
      payeeAddressLine1: taxEntity?.payeeAddressLine1 ?? '',
      payeeAddressLine2: taxEntity?.payeeAddressLine2 ?? '',
      payeeCity: taxEntity?.payeeCity ?? '',
      payeeState: taxEntity?.payeeState ?? '',
      payeeZip: taxEntity?.payeeZip ?? '',
      payeeVoicePhone: taxEntity?.payeeVoicePhone ?? '',
      payeeEmail: taxEntity?.payeeEmail ?? '',
      payeeNPI: taxEntity?.payeeNPI ?? '',
      w9DocumentID: taxEntity?.w9DocumentID == null ? null : Number(taxEntity.w9DocumentID),
      serviceLocationSameAsPayee: !!taxEntity?.serviceLocationSameAsPayee,
      activeFlg: taxEntity?.activeFlg == null ? true : !!taxEntity.activeFlg,
      userId: Number(taxEntity?.userId ?? userId),
      isTinFromDW: !!taxEntity?.isTinFromDW
    };
  }

  private resolvePersistableW9DocumentId(): number | null {
    if (this.w9DocumentId === undefined || this.w9DocumentId === null || `${this.w9DocumentId}` === '') {
      return null;
    }

    const parsedW9DocumentId = Number(this.w9DocumentId);
    if (!Number.isInteger(parsedW9DocumentId) || parsedW9DocumentId <= 0) {
      return null;
    }

    const allDocuments = this.getStorageArray('documents');
    const hasLocalDocument = allDocuments.some((document: any) => `${document?.documentId ?? ''}` === `${parsedW9DocumentId}`);

    return hasLocalDocument ? parsedW9DocumentId : null;
  }

  formatDate(date: any) {
    if (!date) return null;
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  private completeAndNavigateToLocationsLanding() {
    this.saveCompleted.emit();
    this.navigateToLocationsLanding();
  }

  private navigateToLocationsLanding() {
    this.router.navigateByUrl('/credentialing/locations', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/credentialing/locations']);
    });
  }

  private getW9DownloadFileName(): string {
    const fileName = this.W9fileName || this.w9Documents?.[0]?.name || 'W9';
    return /\.pdf$/i.test(fileName) ? fileName : `${fileName}.pdf`;
  }

  onViewDocument(): any {
    this.loaderService.show();
    this.dentalCredentialingService.viewAzureDocument(this.W9fileName).subscribe({
      next: (response: any) => {
        const blob = new Blob([response.body], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.getW9DownloadFileName();
        link.click();
        window.URL.revokeObjectURL(url);
        this.loaderService.hide();
      }, error: (err: any) => {
        this.sharedService.logError(
          "APIFailed",
          "FileDental-Create-tin - viewAzureDocument, Method:onViewDocument",
          this.router.url.split('?')[0],
          err
        ).subscribe();
        this.loaderService.hide();
      }
    })
  }
  bindFormData(isEditMode?: any) {
    if (!isEditMode) {
      if (this.isLocationEditMode && !!this.locationMetaInput?.isMergedLocationEditMode && this.locationFormGroupInput) {
        const locationData = this.locationFormGroupInput.getRawValue();
        const editedTin = this.getFirstNonEmpty(locationData, ['tin']) || '';
        const tinDetails = JSON.parse(localStorage.getItem('TINDetails') || '[]');
        const locationLookupIds = this.getLocationLookupIds(locationData);
        const matchingTinDetail = this.findTinDetailForLocation(tinDetails, editedTin, locationLookupIds);

        this.TINdata = {
          ...locationData,
          ...matchingTinDetail,
          taxId: editedTin || this.getFirstNonEmpty(matchingTinDetail, ['taxId', 'tin']) || '',
          tin: editedTin || this.getFirstNonEmpty(matchingTinDetail, ['taxId', 'tin']) || ''
        };

        if (matchingTinDetail) {
          this.TINdata = {
            ...this.TINdata,
            taxTypeId: this.getFirstNonEmpty(matchingTinDetail, ['taxTypeId']) ?? this.TINdata.taxTypeId,
            taxEntityName: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityName']) || this.TINdata.taxEntityName,
            taxEntityAddress1: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityAddress1']) || this.TINdata.taxEntityAddress1,
            taxEntityAddress2: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityAddress2']) || this.TINdata.taxEntityAddress2,
            taxEntityCity: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityCity']) || this.TINdata.taxEntityCity,
            taxEntityState: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityState']) || this.TINdata.taxEntityState,
            taxEntityZip: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityZip']) || this.TINdata.taxEntityZip,
            taxEntityVoicePhone: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityVoicePhone']) || this.TINdata.taxEntityVoicePhone,
            taxEntityEffectiveDate: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityEffectiveDate']) || this.TINdata.taxEntityEffectiveDate,
            isTinFromDW: this.getFirstNonEmpty(matchingTinDetail, ['isTinFromDW', 'IsTinFromDW']) ?? this.TINdata.isTinFromDW,
            serviceLocationSameAsPayee: this.getFirstNonEmpty(matchingTinDetail, ['serviceLocationSameAsPayee', 'serviceLocationChecked']) ?? this.TINdata.serviceLocationSameAsPayee,
          };
        }
        this.beforeFormData = this.TINdata;
      } else {
      const selectedLocationRecord = sessionStorage.getItem('selectedLocationRecord')
      if (selectedLocationRecord) {
        const parsedRecord = JSON.parse(selectedLocationRecord);
        const selectedTin = this.getFirstNonEmpty(parsedRecord, ['taxId', 'tin']);
        const tinDetails = JSON.parse(localStorage.getItem('TINDetails') || '[]');
        const locationLookupIds = this.getLocationLookupIds(parsedRecord);
        const matchingTinDetail = this.findTinDetailForLocation(tinDetails, selectedTin, locationLookupIds);
        this.TINdata = {
          ...parsedRecord,
          ...matchingTinDetail,
          taxId: this.getFirstNonEmpty(parsedRecord, ['taxId', 'tin']) || matchingTinDetail?.taxId || ''
        };
        if (this.locationMetaInput?.isMergedLocationEditMode && matchingTinDetail) {
          this.TINdata = {
            ...this.TINdata,
            taxTypeId: this.getFirstNonEmpty(matchingTinDetail, ['taxTypeId']) ?? this.TINdata.taxTypeId,
            taxEntityName: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityName']) || this.TINdata.taxEntityName,
            taxEntityAddress1: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityAddress1']) || this.TINdata.taxEntityAddress1,
            taxEntityAddress2: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityAddress2']) || this.TINdata.taxEntityAddress2,
            taxEntityCity: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityCity']) || this.TINdata.taxEntityCity,
            taxEntityState: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityState']) || this.TINdata.taxEntityState,
            taxEntityZip: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityZip']) || this.TINdata.taxEntityZip,
            taxEntityVoicePhone: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityVoicePhone']) || this.TINdata.taxEntityVoicePhone,
            taxEntityEffectiveDate: this.getFirstNonEmpty(matchingTinDetail, ['taxEntityEffectiveDate']) || this.TINdata.taxEntityEffectiveDate,
            isTinFromDW: this.getFirstNonEmpty(matchingTinDetail, ['isTinFromDW', 'IsTinFromDW']) ?? this.TINdata.isTinFromDW,
          };
        }
        this.beforeFormData = this.TINdata;
      } else if ((this.locationMetaInput?.isLocationFromTinSearch || this.locationMetaInput?.isExistingTinNewLocationFlow) && this.locationFormGroupInput) {
        const locationData = this.locationFormGroupInput.getRawValue();
        const searchedTin = this.getFirstNonEmpty(locationData, ['tin']) || localStorage.getItem('SearchedTin') || sessionStorage.getItem('isNewLocationTIN') || '';
        const searchTinResponse = JSON.parse(localStorage.getItem('SearchTINResponse') || '[]');
        const storedTaxEntityTin = localStorage.getItem(this.SEARCH_TIN_TAX_ENTITY_TIN_KEY) || '';
        const storedTaxEntityDetails = JSON.parse(localStorage.getItem(this.SEARCH_TIN_TAX_ENTITY_KEY) || '{}');
        const matchingSearchTinRecord = Array.isArray(searchTinResponse)
          ? (searchTinResponse.find((item: any) => this.isSameTinIdentifier(item?.taxId ?? item?.tin, searchedTin)) || {})
          : {};
        const fallbackTaxEntityRecord = (
          `${storedTaxEntityTin}` === `${searchedTin}` &&
          storedTaxEntityDetails &&
          typeof storedTaxEntityDetails === 'object'
        ) ? storedTaxEntityDetails : {};
        const searchTinRecord = Object.keys(matchingSearchTinRecord).length
          ? matchingSearchTinRecord
          : fallbackTaxEntityRecord;
        const tinDetails = JSON.parse(localStorage.getItem('TINDetails') || '[]');
        const matchingTinDetail = tinDetails.find((item: any) => this.isSameTinIdentifier(item?.taxId ?? item?.tin, searchedTin)) || {};
        const shouldOverlayLocationData = !!this.locationMetaInput?.isLocationFromTinSearch;
        this.TINdata = {
          ...searchTinRecord,
          ...matchingTinDetail,
          ...(shouldOverlayLocationData ? locationData : {}),
          taxId: this.getFirstNonEmpty(matchingTinDetail, ['taxId', 'tin']) || this.getFirstNonEmpty(searchTinRecord, ['taxId', 'tin']) || searchedTin,
          tin: searchedTin,
          name: shouldOverlayLocationData
            ? this.getFirstNonEmpty(locationData, ['name']) || this.getFirstNonEmpty(matchingTinDetail, ['taxEntityName', 'payeeName', 'name']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityName', 'payeeName', 'name']) || ''
            : this.getFirstNonEmpty(matchingTinDetail, ['taxEntityName', 'payeeName', 'name']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityName', 'payeeName', 'name']) || this.getFirstNonEmpty(locationData, ['name']) || '',
          address1: shouldOverlayLocationData
            ? this.getFirstNonEmpty(locationData, ['location', 'address', 'address1']) || this.getFirstNonEmpty(matchingTinDetail, ['taxEntityAddress1', 'payeeAddress1', 'payeeAddressLine1', 'address1', 'address']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityAddress1', 'payeeAddress1', 'payeeAddressLine1', 'address1', 'address']) || ''
            : this.getFirstNonEmpty(matchingTinDetail, ['taxEntityAddress1', 'payeeAddress1', 'payeeAddressLine1', 'address1', 'address']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityAddress1', 'payeeAddress1', 'payeeAddressLine1', 'address1', 'address']) || this.getFirstNonEmpty(locationData, ['location', 'address', 'address1']) || '',
          city: shouldOverlayLocationData
            ? this.getFirstNonEmpty(locationData, ['city']) || this.getFirstNonEmpty(matchingTinDetail, ['taxEntityCity', 'payeeCity', 'city']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityCity', 'payeeCity', 'city']) || ''
            : this.getFirstNonEmpty(matchingTinDetail, ['taxEntityCity', 'payeeCity', 'city']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityCity', 'payeeCity', 'city']) || this.getFirstNonEmpty(locationData, ['city']) || '',
          state: shouldOverlayLocationData
            ? this.getFirstNonEmpty(locationData, ['state']) || this.getFirstNonEmpty(matchingTinDetail, ['taxEntityState', 'payeeState', 'state']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityState', 'payeeState', 'state']) || ''
            : this.getFirstNonEmpty(matchingTinDetail, ['taxEntityState', 'payeeState', 'state']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityState', 'payeeState', 'state']) || this.getFirstNonEmpty(locationData, ['state']) || '',
          zip: shouldOverlayLocationData
            ? this.getFirstNonEmpty(locationData, ['zip']) || this.getFirstNonEmpty(matchingTinDetail, ['taxEntityZip', 'payeeZip', 'zip']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityZip', 'payeeZip', 'zip']) || ''
            : this.getFirstNonEmpty(matchingTinDetail, ['taxEntityZip', 'payeeZip', 'zip']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityZip', 'payeeZip', 'zip']) || this.getFirstNonEmpty(locationData, ['zip']) || '',
          voicePhone: shouldOverlayLocationData
            ? this.getFirstNonEmpty(locationData, ['voicePhone']) || this.getFirstNonEmpty(matchingTinDetail, ['taxEntityVoicePhone', 'payeeVoicePhone', 'voicePhone', 'phone']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityVoicePhone', 'payeeVoicePhone', 'voicePhone', 'phone']) || ''
            : this.getFirstNonEmpty(matchingTinDetail, ['taxEntityVoicePhone', 'payeeVoicePhone', 'voicePhone', 'phone']) || this.getFirstNonEmpty(searchTinRecord, ['taxEntityVoicePhone', 'payeeVoicePhone', 'voicePhone', 'phone']) || this.getFirstNonEmpty(locationData, ['voicePhone']) || '',
          email: shouldOverlayLocationData
            ? this.getFirstNonEmpty(locationData, ['email']) || this.getFirstNonEmpty(matchingTinDetail, ['payeeEmail', 'taxEntityEmail', 'email']) || this.getFirstNonEmpty(searchTinRecord, ['payeeEmail', 'taxEntityEmail', 'email']) || ''
            : this.getFirstNonEmpty(matchingTinDetail, ['payeeEmail', 'taxEntityEmail', 'email']) || this.getFirstNonEmpty(searchTinRecord, ['payeeEmail', 'taxEntityEmail', 'email']) || this.getFirstNonEmpty(locationData, ['email']) || '',
          serviceLocationSameAsPayee: this.getFirstNonEmpty(matchingTinDetail, ['serviceLocationSameAsPayee', 'serviceLocationChecked']) ??
            this.getFirstNonEmpty(searchTinRecord, ['serviceLocationSameAsPayee', 'serviceLocationChecked']) ??
            this.getFirstNonEmpty(locationData, ['serviceLocationChecked']),
        };
        this.beforeFormData = this.TINdata;
      } else if (sessionStorage.getItem('isNewLocationTIN')) {
        const newLocationTIN = sessionStorage.getItem('isNewLocationTIN')
        let TIN = newLocationTIN ? newLocationTIN : ''
        this.tinFormGroup.patchValue({
          'taxId': TIN
        })
      }
      }
      this.TINdata = this.TINdata || {};
      if (this.isW9Alert) {
        this.payeeID = this.TINdata.payeeId ? this.TINdata.payeeId : null
      }
    }
    if (isEditMode) {
      this.TINdata = this.editTinData;
      this.beforeFormData = this.editTinData;
      this.payeeID = this.TINdata.payeeId ? this.TINdata.payeeId : null;
    }
    this.hydrateW9DocumentState(this.TINdata?.w9DocumentID ?? this.TINdata?.w9DocumentId ?? null);
    const locationFormData: any = this.locationFormGroupInput?.getRawValue?.() || {};
    const taxIdTypeValue = this.TINdata.taxTypeId !== undefined && this.TINdata.taxTypeId !== null && this.TINdata.taxTypeId !== ''
      ? this.TINdata.taxTypeId.toString()
      : '2';
    const taxEntityNameValue = this.getFirstNonEmpty(this.TINdata, ['taxEntityName', 'name', 'payeeName']) || '';
    const taxEntityAddress1Value =
      this.getFirstNonEmpty(this.TINdata, ['taxEntityAddress1', 'address1', 'location', 'address', 'payeeAddress1', 'payeeAddressLine1']) ||
      this.getFirstNonEmpty(locationFormData, ['location', 'address', 'address1']) ||
      '';
    const taxEntityAddress2Value = this.getFirstNonEmpty(this.TINdata, ['taxEntityAddress2', 'address2', 'payeeAddress2', 'payeeAddressLine2']) || '';
    const taxEntityCityValue =
      this.getFirstNonEmpty(this.TINdata, ['taxEntityCity', 'city', 'payeeCity']) ||
      this.getFirstNonEmpty(locationFormData, ['city']) ||
      '';
    const taxEntityStateValue =
      this.getFirstNonEmpty(this.TINdata, ['taxEntityState', 'state', 'payeeState']) ||
      this.getFirstNonEmpty(locationFormData, ['state']) ||
      '';
    const taxEntityZipValue =
      this.getFirstNonEmpty(this.TINdata, ['taxEntityZip', 'zip', 'payeeZip']) ||
      this.getFirstNonEmpty(locationFormData, ['zip']) ||
      '';
    const taxEntityPhoneValue =
      this.getFirstNonEmpty(this.TINdata, ['taxEntityVoicePhone', 'phone', 'voicePhone', 'payeeVoicePhone', 'payeePhone']) ||
      this.getFirstNonEmpty(locationFormData, ['voicePhone']) ||
      '';
    const payeeNameValue = this.getFirstNonEmpty(this.TINdata, ['payeeName', 'name', 'taxEntityName']) || '';
    const payeeAddress1Value =
      this.getFirstNonEmpty(this.TINdata, ['payeeAddress1', 'payeeLocation', 'payeeAddressLine1', 'payeeAddress', 'address1', 'location', 'taxEntityAddress1']) ||
      this.getFirstNonEmpty(locationFormData, ['location', 'address', 'address1']) ||
      '';
    const payeeAddress2Value = this.getFirstNonEmpty(this.TINdata, ['payeeAddress2', 'payeeAddressLine2', 'address2', 'taxEntityAddress2']) || '';
    const payeeCityValue =
      this.getFirstNonEmpty(this.TINdata, ['payeeCity', 'city', 'taxEntityCity']) ||
      this.getFirstNonEmpty(locationFormData, ['city']) ||
      '';
    const payeeStateValue =
      this.getFirstNonEmpty(this.TINdata, ['payeeState', 'state', 'taxEntityState']) ||
      this.getFirstNonEmpty(locationFormData, ['state']) ||
      '';
    const payeeZipValue =
      this.getFirstNonEmpty(this.TINdata, ['payeeZip', 'zip', 'taxEntityZip']) ||
      this.getFirstNonEmpty(locationFormData, ['zip']) ||
      '';
    const payeePhoneValue =
      this.getFirstNonEmpty(this.TINdata, ['payeeVoicePhone', 'payeePhone', 'voicePhone', 'phone', 'taxEntityVoicePhone']) ||
      this.getFirstNonEmpty(locationFormData, ['voicePhone']) ||
      '';
    const payeeEmailValue =
      this.TINdata?.payeeEmail ??
      this.TINdata?.taxEntityEmail ??
      '';
    const payeeNpiRawValue = this.getFirstNonEmpty(this.TINdata, ['payeeNPI', 'providerNpi2', 'npi2']) || '';
    const payeeNpiValue = typeof payeeNpiRawValue === 'string' && payeeNpiRawValue.trim().toLowerCase() === 'unknown'
      ? ''
      : payeeNpiRawValue.trim();
    const taxIdValue = this.getFirstNonEmpty(this.TINdata, ['taxId', 'tin']) || '';

    let effectiveDate = this.formatStaticNumberDate(this.TINdata.effectiveDate);
    if (!effectiveDate) effectiveDate = this.TINdata.taxEntityEffectiveDate || null;
    if (!effectiveDate) effectiveDate = this.TINdata.effectiveDate || null;
    if (!effectiveDate) this.tinFormGroup.get('effectiveDate')?.enable();
    this.tinFormGroup.patchValue({
      taxIdType: taxIdTypeValue,
      taxId: taxIdValue,
      taxEntityName: taxEntityNameValue,
      location: taxEntityAddress1Value,
      address2: taxEntityAddress2Value,
      city: taxEntityCityValue,
      state: taxEntityStateValue,
      zip: taxEntityZipValue,
      phone: taxEntityPhoneValue,
      effectiveDate: effectiveDate
    })

    if (this.TINdata && (this.TINdata.taxTypeId == 0 || this.TINdata.taxTypeId == -1)) {
      this.tinFormGroup.patchValue({
        taxIdType: '2'
      })
    }
    this.payeeFormGroup.patchValue({
      payeeName: payeeNameValue,
      payeeLocation: payeeAddress1Value,
      payeeAddress2: payeeAddress2Value,
      payeeCity: payeeCityValue,
      payeeState: payeeStateValue,
      payeeZip: payeeZipValue,
      payeePhone: payeePhoneValue,
      payeeEmail: payeeEmailValue,
      npi2: payeeNpiValue
    }, { emitEvent: false })
    const rawSameAsPayee = this.getFirstNonEmpty(this.TINdata, ['serviceLocationSameAsPayee', 'serviceLocationChecked']) ??
      this.getFirstNonEmpty(locationFormData, ['serviceLocationChecked']);
    const isServiceLocationChecked = (rawSameAsPayee === 1 || rawSameAsPayee === '1' || rawSameAsPayee === true || rawSameAsPayee === 'true');
    this.serviceCheckForm.patchValue({
      serviceLocationChecked: isServiceLocationChecked
    }, { emitEvent: false })
    if (this.isDwMergedLocationEditMode) {
      this.applyReadOnlyPayeeStateWithNpiOverride();
      this.serviceCheckForm.disable({ emitEvent: false });
    } else {
      this.setPayeeEditState(isServiceLocationChecked);
    }

    const isDwTin = this.isDwTinFlag(this.TINdata);
    this.isTinFromDW = isDwTin;
    const effectiveDateControl = this.tinFormGroup.get('effectiveDate');
    if (isDwTin) {
      effectiveDateControl?.clearValidators();
      effectiveDateControl?.setValue(null, { emitEvent: false });
    } else {
      effectiveDateControl?.setValidators([Validators.required, this.effectiveDateBeforeOrOnLocationStartDateValidator.bind(this)]);
    }
    effectiveDateControl?.updateValueAndValidity({ emitEvent: false });
    if (this.isLocationEditMode && !!this.locationMetaInput?.isMergedLocationEditMode) {
      this.applyMergedEditTinFieldState(isDwTin);
      this.tinFormGroup.updateValueAndValidity();
      return;
    }
    if (!isEditMode || (isEditMode && isDwTin)) {
      this.disableFormFields(isEditMode)
    }
    if (isEditMode && !isDwTin) {
      this.tinFormGroup.disable()
      this.tinFormGroup.get('taxIdType')?.enable()
      this.tinFormGroup.get('effectiveDate')?.enable()
      this.tinFormGroup.get('w9Control')?.enable()
    }
    this.tinFormGroup.updateValueAndValidity();
  }
  private hydrateW9DocumentState(existingW9DocumentId: any) {
    if (!existingW9DocumentId) {
      this.showW9Asterisk = true;
      this.w9DocumentId = '';
      this.w9Documents = [];
      return;
    }

    const docs = localStorage.getItem('documents');
    const allDocs = docs ? this.getStorageArray('documents') : [];
    const w9Doc = allDocs.find((doc: any) => `${doc.documentId}` === `${existingW9DocumentId}`);

    this.w9DocumentId = `${existingW9DocumentId}`;

    if (w9Doc && w9Doc.fileName) {
      this.W9fileName = w9Doc.fileName;
      this.w9Documents = [{
        originalFileName: `${this.W9fileName}.pdf`,
        name: w9Doc.originalFileName || 'W9.pdf'
      }];
      this.showW9Asterisk = false;
      return;
    }

    this.w9Documents = [{
      originalFileName: 'W9.pdf',
      name: 'W9.pdf'
    }];
    this.showW9Asterisk = false;
  }
  enforceReadOnlyTinAndPayeeSections() {
    this.tinFormGroup.disable();
    this.payeeFormGroup.disable();
    this.serviceCheckForm.disable();
    this.toggleNpi2ForReadOnlyPayeeSection();
  }

  private applyReadOnlyPayeeStateWithNpiOverride() {
    this.payeeFormGroup.disable({ emitEvent: false });
    this.toggleNpi2ForReadOnlyPayeeSection();
  }

  private toggleNpi2ForReadOnlyPayeeSection() {
    const npiControl = this.payeeFormGroup.get('npi2');
    if (!npiControl) {
      return;
    }
    if (this.impersonatedUser) {
      npiControl.disable({ emitEvent: false });
      return;
    }
    const rawValue = npiControl.value;
    const normalizedValue = typeof rawValue === 'string' ? rawValue.trim() : `${rawValue ?? ''}`.trim();
    if (!normalizedValue || normalizedValue.toLowerCase() === 'unknown') {
      npiControl.enable({ emitEvent: false });
      return;
    }
    npiControl.disable({ emitEvent: false });
  }

  private preparePayeeForExistingTinNewLocation() {
    const locationData: any = this.locationFormGroupInput?.getRawValue?.() || {};
    const resolvedName = this.getFirstNonEmpty(locationData, ['name']) || '';
    this.payeeFormGroup.patchValue({
      payeeName: resolvedName,
      payeeLocation: '',
      payeeAddress2: '',
      payeeCity: '',
      payeeState: '',
      payeeZip: '',
      payeePhone: '',
      payeeEmail: '',
      npi2: ''
    }, { emitEvent: false });

    this.serviceCheckForm.patchValue({
      serviceLocationChecked: false
    }, { emitEvent: false });
    this.selectedExistingPayeeControl.setValue('', { emitEvent: false });

    this.payeeFormGroup.enable();
    this.payeeFormGroup.get('payeeName')?.disable();
    this.updateServiceLocationCheckboxState();
    this.tinFormGroup.disable();
    this.tinFormGroup.get('w9Control')?.enable();
  }

  onExistingPayeeSelected() {
    const selectedPayee = this.existingPayees[Number(this.selectedExistingPayeeControl.value)];
    if (!selectedPayee) {
      this.setStoredExistingPayeeSelectionAddress(null);
      return;
    }

    this.serviceCheckForm.patchValue({ serviceLocationChecked: false }, { emitEvent: false });
    this.payeeFormGroup.enable({ emitEvent: false });
    this.payeeFormGroup.patchValue({
      payeeName: this.getFirstNonEmpty(selectedPayee, ['payeeName', 'name']) || '',
      payeeLocation: this.getFirstNonEmpty(selectedPayee, ['payeeAddress1', 'payeeAddressLine1', 'payeeLocation', 'address1', 'address']) || '',
      payeeAddress2: this.getFirstNonEmpty(selectedPayee, ['payeeAddress2', 'payeeAddressLine2', 'address2']) || '',
      payeeCity: this.getFirstNonEmpty(selectedPayee, ['payeeCity', 'city']) || '',
      payeeState: this.getFirstNonEmpty(selectedPayee, ['payeeState', 'state']) || '',
      payeeZip: this.getFirstNonEmpty(selectedPayee, ['payeeZip', 'zip']) || '',
      payeePhone: this.getFirstNonEmpty(selectedPayee, ['payeeVoicePhone', 'payeePhone', 'voicePhone', 'phone']) || '',
      payeeEmail: this.getFirstNonEmpty(selectedPayee, ['payeeEmail', 'email']) || '',
      npi2: this.getFirstNonEmpty(selectedPayee, ['payeeNPI', 'providerNpi2', 'npi2']) || ''
    }, { emitEvent: false });
    this.setStoredExistingPayeeSelectionAddress(this.formatExistingPayeeAddress(selectedPayee));
    this.setPayeeEditState(true);
    this.updateServiceLocationCheckboxState();
  }

  clearExistingPayee() {
    this.selectedExistingPayeeControl.setValue('', { emitEvent: false });
    this.setStoredExistingPayeeSelectionAddress(null);
    this.serviceCheckForm.patchValue({ serviceLocationChecked: false }, { emitEvent: false });
    this.clearPayeeFieldsForExistingTinNewLocation();
    this.setPayeeEditState(false);
    this.updateServiceLocationCheckboxState();
    this.showErrorPayee = false;
    this.showFulladdressErrorPayee = false;
  }

  private initializeExistingPayeeOptions() {
    const searchedTin = this.getFirstNonEmpty(this.TINdata, ['taxId', 'tin']) || localStorage.getItem('SearchedTin');
    const distinctPayeesTin = localStorage.getItem('SearchTINDistinctPayeesTin') || '';
    const storedDistinctPayees = JSON.parse(localStorage.getItem('SearchTINDistinctPayees') || '[]');
    const searchTinResponse = JSON.parse(localStorage.getItem('SearchTINResponse') || '[]');
    const matchingRecords = Array.isArray(searchTinResponse)
      ? searchTinResponse.filter((record: any) => this.isSameTinIdentifier(record?.taxId ?? record?.tin, searchedTin))
      : [];
    const payeesFromSearch = (this.isSameTinIdentifier(distinctPayeesTin, searchedTin) && Array.isArray(storedDistinctPayees))
      ? storedDistinctPayees
      : [];
    const tinDetails = JSON.parse(localStorage.getItem('TINDetails') || '[]');
    const tinDetailRows = Array.isArray(tinDetails) ? tinDetails : [];
    const payeesFromTinDetails = tinDetailRows
      .filter((item: any) => this.isSameTinIdentifier(item?.taxId ?? item?.tin, searchedTin))
      .filter((item: any) =>
        this.getFirstNonEmpty(item, ['payeeAddress1', 'payeeAddressLine1', 'payeeLocation', 'address1', 'address'])
      );
    const payeesFromSearchCache = payeesFromSearch.length
      ? payeesFromSearch
      : matchingRecords.flatMap((record: any) =>
        Array.isArray(record?.existingPayees) ? record.existingPayees : [record]
      );
    const resolvedPayees = [...payeesFromSearchCache, ...payeesFromTinDetails];
    const seenAddresses = new Set<string>();
    this.existingPayees = resolvedPayees.filter((payee: any) => {
      const addressKey = this.formatExistingPayeeAddress(payee).toLowerCase();
      if (!addressKey || seenAddresses.has(addressKey)) {
        return false;
      }
      seenAddresses.add(addressKey);
      return true;
    });
    this.existingPayeeOptions = this.existingPayees.map((payee: any, index: number) => ({
      value: `${index}`,
      viewValue: this.formatExistingPayeeAddress(payee)
    }));
  }

  private formatExistingPayeeAddress(payee: any): string {
    return [
      this.getFirstNonEmpty(payee, ['payeeAddress1', 'payeeAddressLine1', 'payeeLocation', 'address1', 'address']),
      this.getFirstNonEmpty(payee, ['payeeAddress2', 'payeeAddressLine2', 'address2']),
      this.getFirstNonEmpty(payee, ['payeeCity', 'city']),
      this.getFirstNonEmpty(payee, ['payeeState', 'state']),
      this.getFirstNonEmpty(payee, ['payeeZip', 'zip'])
    ].filter(Boolean).join(', ');
  }

  private normalizeAddressValue(value: any): string {
    return `${value ?? ''}`.trim().toLowerCase();
  }

  private preparePayeeForExistingTinNewLocationEdit() {
    this.updateServiceLocationCheckboxState();
    this.tinFormGroup.disable();
    this.tinFormGroup.get('w9Control')?.enable();

    const isServiceLocationChecked = !!this.serviceCheckForm.get('serviceLocationChecked')?.value;
    if (isServiceLocationChecked) {
      this.selectedExistingPayeeControl.setValue('', { emitEvent: false });
      this.setStoredExistingPayeeSelectionAddress(null);
      this.setPayeeEditState(true, false);
      this.updateServiceLocationCheckboxState();
      return;
    }

    const storedAddress = this.normalizeAddressValue(this.getStoredExistingPayeeSelectionAddress());
    const matchedPayeeIndex = storedAddress
      ? this.existingPayees.findIndex((payee: any) => {
        const normalizedPayeeAddress = this.normalizeAddressValue(this.formatExistingPayeeAddress(payee));
        return normalizedPayeeAddress === storedAddress ||
          normalizedPayeeAddress.includes(storedAddress) ||
          storedAddress.includes(normalizedPayeeAddress);
      })
      : -1;
    if (matchedPayeeIndex >= 0) {
      this.selectedExistingPayeeControl.setValue(`${matchedPayeeIndex}`, { emitEvent: false });
      this.setStoredExistingPayeeSelectionAddress(this.formatExistingPayeeAddress(this.existingPayees[matchedPayeeIndex]));
      this.setPayeeEditState(true, false);
      this.updateServiceLocationCheckboxState();
      return;
    }

    this.selectedExistingPayeeControl.setValue('', { emitEvent: false });
    this.setPayeeEditState(false);
    this.updateServiceLocationCheckboxState();
  }

  private patchPayeeFromLocationForExistingTinNewLocation() {
    const locationData: any = this.locationFormGroupInput?.getRawValue?.() || {};
    this.payeeFormGroup.patchValue({
      payeeName: this.getFirstNonEmpty(locationData, ['name']) || '',
      payeeLocation: this.getFirstNonEmpty(locationData, ['location', 'address', 'address1']) || '',
      payeeAddress2: '',
      payeeCity: this.getFirstNonEmpty(locationData, ['city']) || '',
      payeeState: this.getFirstNonEmpty(locationData, ['state']) || '',
      payeeZip: this.getFirstNonEmpty(locationData, ['zip']) || '',
      payeePhone: this.getFirstNonEmpty(locationData, ['voicePhone']) || '',
      payeeEmail: this.getFirstNonEmpty(locationData, ['email']) || '',
    }, { emitEvent: false });
  }

  private clearPayeeFieldsForExistingTinNewLocation() {
    this.payeeFormGroup.patchValue({
      payeeName: '',
      payeeLocation: '',
      payeeAddress2: '',
      payeeCity: '',
      payeeState: '',
      payeeZip: '',
      payeePhone: '',
      payeeEmail: '',
      npi2: ''
    }, { emitEvent: false });
  }
  disableFormFields(isEditMode?: any) {
    this.tinFormGroup.disable()
    // Disable controls that have values
    if (this.TINdata && this.TINdata.isTinFromDW) {
      Object.keys(this.payeeFormGroup.controls).forEach(key => {
        const control = this.payeeFormGroup.get(key);
        if ((control?.value) || (control && key == 'payeeAddress2')) {
          control.disable();
        }
      });
    } else if (!this.isLocationEditMode) {
      this.payeeFormGroup.disable()
    }
    if (!this.isLocationEditMode) {
      this.serviceCheckForm.disable()
    }
    if (!isEditMode) {
      this.tinFormGroup.get('effectiveDate')?.enable()
    }
    this.tinFormGroup.get('w9Control')?.enable()
  }
  createNeedtoDisable() {
    const isPrimaryLocation = this.locationMetaInput?.isPrimary === 'yes';
    const isDirectoryInfoSigned = this.locationMetaInput
      ? this.locationMetaInput?.isDirectoryInfoCompleted === true
      : localStorage.getItem(this.DIRECTORY_INFO_SIGNED_KEY) === 'true';
    const isLocationDirectoryIncomplete = isPrimaryLocation && !isDirectoryInfoSigned;
    const hasInvalidTinOrPayeeState = this.hasInvalidTinOrPayeeSaveState(false);
    const hasInvalidLocationState = this.hasInvalidParentLocationSaveState(false);

    if (this.isEditMode) {
      return (
        hasInvalidLocationState ||
        hasInvalidTinOrPayeeState ||
       (this.isW9Required && !this.w9DocumentId) ||
       (this.isW9Required && this.w9Documents.length === 0) ||
        isLocationDirectoryIncomplete
      );
    }
    if (this.isW9Alert) {
      return (
        hasInvalidLocationState ||
        hasInvalidTinOrPayeeState ||
        (this.isW9Required && !this.w9DocumentId) ||
        isLocationDirectoryIncomplete
      );
    }
    return (
      hasInvalidLocationState ||
      hasInvalidTinOrPayeeState ||
      (this.isW9Required && !this.w9DocumentId) ||
      (this.isW9Required && this.w9Documents.length === 0) ||
      isLocationDirectoryIncomplete ||
      this.showFulladdressErrorPayee ||
      this.showFulladdressError
    );
  }
  TINExistsAlertPopupCall(isNewTINSaveAlert?: boolean) {
    this.loaderService.hide()
    let alertMessage: any
    if (isNewTINSaveAlert) {
      alertMessage = 'Unsaved location and payee details will be lost. Are you sure you want to leave this page?'
    } else {
      alertMessage = "This TIN already exists. Please search by TIN and select/add location.";
    }
    let dialogRef = this.dialog.open(W9AlertComponent, {
      disableClose: true,
      data: { message: alertMessage },
      width: '550px',
      backdropClass: '',
      hasBackdrop: true,
    });
    return dialogRef.afterClosed();
  }
  bindFormUsingLatestLocationRecord() {
    const key = this.latestlocation[0]['isParticipating'] ? 'startPracticingAt' : 'endedPracticingAt';
    this.beforeFormData = {
      ...this.latestlocation[0], [key]: this.latestlocation[0][key] ? this.latestlocation[0][key] : null
    }
    this.patchFormsFromLatestLocation();

    const isServiceLocationChecked = !!this.latestlocation[0]['serviceLocationChecked'];
    this.serviceCheckForm.patchValue({
      serviceLocationChecked: isServiceLocationChecked
    }, { emitEvent: false });
    this.enableTinForManualEdit();
    this.setPayeeEditState(isServiceLocationChecked);
  }

  patchFormsFromLatestLocation() {
    const source = this.latestlocation?.[0] || {};
    const key = source['isParticipating'] ? 'startPracticingAt' : 'endedPracticingAt';
    const tinData: any = this.tinFormGroup.getRawValue();
    const payeeData: any = this.payeeFormGroup.getRawValue();

    const taxId = this.getFirstNonEmpty(source, ['tin', 'taxId']) || tinData.taxId;
    const location = this.getFirstNonEmpty(source, ['address', 'address1', 'taxEntityAddress1']) || payeeData.payeeLocation || tinData.location;
    const address2 = this.getFirstNonEmpty(source, ['address2', 'payeeAddressLine2', 'taxEntityAddress2']) || payeeData.payeeAddress2 || tinData.address2;
    const city = this.getFirstNonEmpty(source, ['city', 'payeeCity', 'taxEntityCity']) || payeeData.payeeCity || tinData.city;
    const state = this.getFirstNonEmpty(source, ['state', 'payeeState', 'taxEntityState']) || payeeData.payeeState || tinData.state;
    const zip = this.getFirstNonEmpty(source, ['zip', 'payeeZip', 'taxEntityZip']) || payeeData.payeeZip || tinData.zip;
    const phone = this.getFirstNonEmpty(source, ['voicePhone', 'payeeVoicePhone', 'taxEntityVoicePhone']) || payeeData.payeePhone || tinData.phone;
    const name = this.getFirstNonEmpty(source, ['name', 'payeeName', 'taxEntityName']) || payeeData.payeeName || tinData.taxEntityName;
    const email = this.getFirstNonEmpty(source, ['email', 'payeeEmail']) || payeeData.payeeEmail;
    const effectiveDate = this.getFirstNonEmpty(source, [key, 'effectiveDate', 'taxEntityEffectiveDate']) || tinData.effectiveDate || null;

    this.patchTinAndPayeeForms({
      taxId: taxId,
      taxEntityName: name,
      location: location,
      address2: address2,
      city: city,
      state: state,
      zip: zip,
      phone: phone,
      payeeName: name,
      payeeLocation: location,
      payeeAddress2: address2,
      payeeCity: city,
      payeeState: state,
      payeeZip: zip,
      payeePhone: phone,
      payeeEmail: email,
      effectiveDate: effectiveDate
    });
  }

  getFirstNonEmpty(source: any, keys: string[]): any {
    for (const key of keys) {
      const value = source?.[key];
      if (value !== undefined && value !== null && value !== '') {
        return value;
      }
    }
    return null;
  }

  private normalizeTinIdentifier(value: any): string {
    if (value === undefined || value === null) {
      return '';
    }
    const normalizedValue = `${value}`.trim();
    if (!normalizedValue) {
      return '';
    }
    const digitsOnly = normalizedValue.replace(/[^0-9]/g, '');
    return digitsOnly || normalizedValue;
  }

  private isSameTinIdentifier(left: any, right: any): boolean {
    const normalizedLeft = this.normalizeTinIdentifier(left);
    const normalizedRight = this.normalizeTinIdentifier(right);
    return !!normalizedLeft && !!normalizedRight && normalizedLeft === normalizedRight;
  }

  private getLocationLookupIds(locationData?: any): string[] {
    const candidateIds = [
      this.locationMetaInput?.locationId,
      this.locationMetaInput?.esLocationId,
      this.locationMetaInput?.locationLookupId,
      locationData?.locationId,
      locationData?.esLocationId
    ];

    return [...new Set(
      candidateIds
        .filter((id: any) => id !== undefined && id !== null && `${id}` !== '')
        .map((id: any) => `${id}`)
    )];
  }

  private getTinDetailLocationIds(source: any): string[] {
    return [source?.locationId, source?.esLocationId]
      .filter((id: any) => id !== undefined && id !== null && `${id}` !== '')
      .map((id: any) => `${id}`);
  }

  private findTinDetailIndexForUpdate(tinDetails: any[], payload: any): number {
    const normalizedTaxId = `${payload?.taxId ?? payload?.tin ?? ''}`.trim();
    if (!normalizedTaxId) {
      return -1;
    }

    const locationLookupIds = this.getLocationLookupIds(payload);
    if (locationLookupIds.length > 0) {
      const lookupSet = new Set(locationLookupIds.map((id: any) => `${id}`));
      const matchedIndex = tinDetails.findIndex((item: any) => {
        const itemTaxId = `${item?.taxId ?? item?.tin ?? ''}`.trim();
        if (itemTaxId !== normalizedTaxId) {
          return false;
        }
        const itemLocationIds = this.getTinDetailLocationIds(item);
        return itemLocationIds.some((id: string) => lookupSet.has(id));
      });
      if (matchedIndex !== -1) {
        return matchedIndex;
      }
      return -1;
    }

    return tinDetails.findIndex((item: any) => `${item?.taxId ?? item?.tin ?? ''}`.trim() === normalizedTaxId);
  }

  private buildSharedTinTaxEntityFields(updatedRecord: any): any {
    return {
      taxTypeId: updatedRecord?.taxTypeId ?? 0,
      taxId: updatedRecord?.taxId ?? '',
      tin: updatedRecord?.taxId ?? updatedRecord?.tin ?? '',
      taxEntityId: updatedRecord?.taxEntityId ?? null,
      taxEntityName: updatedRecord?.taxEntityName ?? '',
      taxEntityAddress1: updatedRecord?.taxEntityAddress1 ?? '',
      taxEntityAddress2: updatedRecord?.taxEntityAddress2 ?? '',
      taxEntityCity: updatedRecord?.taxEntityCity ?? '',
      taxEntityState: updatedRecord?.taxEntityState ?? '',
      taxEntityZip: updatedRecord?.taxEntityZip ?? '',
      taxEntityEmail: updatedRecord?.taxEntityEmail ?? updatedRecord?.payeeEmail ?? '',
      taxEntityVoicePhone: updatedRecord?.taxEntityVoicePhone ?? '',
      effectiveDate: updatedRecord?.effectiveDate ?? null,
      w9DocumentID: updatedRecord?.w9DocumentID ?? null,
      isTinFromDW: !!updatedRecord?.isTinFromDW
    };
  }

  private upsertTinDetailRecord(tinDetails: any[], updatedRecord: any, payload: any): any[] {
    const normalizedTaxId = `${updatedRecord?.taxId ?? updatedRecord?.tin ?? ''}`.trim();
    if (!normalizedTaxId) {
      return Array.isArray(tinDetails) ? [...tinDetails] : [];
    }

    const nextTinDetails = Array.isArray(tinDetails) ? [...tinDetails] : [];
    const updateIndex = this.findTinDetailIndexForUpdate(nextTinDetails, payload);
    if (updateIndex !== -1) {
      nextTinDetails[updateIndex] = { ...nextTinDetails[updateIndex], ...updatedRecord };
    } else {
      nextTinDetails.push({ ...updatedRecord });
    }

    const sharedTinTaxEntityFields = this.buildSharedTinTaxEntityFields(updatedRecord);
    return nextTinDetails.map((item: any) => {
      const itemTaxId = `${item?.taxId ?? item?.tin ?? ''}`.trim();
      if (itemTaxId !== normalizedTaxId) {
        return item;
      }
      return { ...item, ...sharedTinTaxEntityFields };
    });
  }

  // Payee rows are now per-location; prefer the exact (taxId, locationId) match over the taxId-only fallback.
  private findTinDetailForLocation(tinDetails: any[], taxId: any, locationIds?: any[] | any): any {
    if (!Array.isArray(tinDetails) || !taxId) {
      return {};
    }
    const taxMatches = tinDetails.filter((item: any) =>
      this.isSameTinIdentifier(item?.taxId ?? item?.tin, taxId)
    );
    const normalizedLookupIds = Array.isArray(locationIds)
      ? locationIds
      : (locationIds !== undefined && locationIds !== null && `${locationIds}` !== '' ? [locationIds] : []);

    if (normalizedLookupIds.length > 0) {
      const lookupSet = new Set(normalizedLookupIds.map((id: any) => `${id}`));
      const exactMatch = taxMatches.find((item: any) => {
        const itemLocationIds = [item?.locationId, item?.esLocationId]
          .filter((id: any) => id !== undefined && id !== null && `${id}` !== '')
          .map((id: any) => `${id}`);
        return itemLocationIds.some((id: string) => lookupSet.has(id));
      });
      if (exactMatch) {
        return exactMatch;
      }
      return taxMatches[0] || {};
    }
    return taxMatches[0] || {};
  }

  private isDwTinFlag(source: any): boolean {
    const value = source?.isTinFromDW ?? source?.IsTinFromDW;
    if (value === true || value === 1) {
      return true;
    }
    const normalizedValue = `${value ?? ''}`.trim().toLowerCase();
    return normalizedValue === 'yes' || normalizedValue === 'true' || normalizedValue === '1';
  }
  canDeactivate(): boolean | Observable<boolean> {
    if (!this.isSaved && localStorage.getItem('isnewTIN') === 'true') {
      return this.TINExistsAlertPopupCall(true);
    }

    return true;
  }
  private shouldPersistDirectoryInfo(saveLocationRecords: any[]): boolean {
    const isPrimaryFromMeta = this.locationMetaInput?.isPrimary === 'yes'
      ? true
      : this.locationMetaInput?.isPrimary === 'no'
        ? false
        : null;
    const isPrimaryLocation = isPrimaryFromMeta !== null
      ? isPrimaryFromMeta
      : saveLocationRecords.some((location: any) => location?.isPrimary === true);
    if (!isPrimaryLocation) {
      return false;
    }

    const isDirectoryInfoCompleted = this.locationMetaInput
      ? this.locationMetaInput?.isDirectoryInfoCompleted === true
      : localStorage.getItem(this.DIRECTORY_INFO_SIGNED_KEY) === 'true';
    return isDirectoryInfoCompleted;
  }

  private normalizeLocationId(value: any): number | null {
    const parsedValue = Number(value);
    if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
      return null;
    }

    return parsedValue;
  }

  private resolveDirectoryLocationId(
    locationId: any,
    savedLocations: any[],
    saveLocationRecords: any[]
  ): number | null {
    const candidateLocationIds = [
      locationId,
      localStorage.getItem('latestCreatedLocationId'),
      ...savedLocations.map((location: any) => location?.locationId),
      ...saveLocationRecords.map((location: any) => location?.locationId)
    ];
    for (const candidateLocationId of candidateLocationIds) {
      const normalizedLocationId = this.normalizeLocationId(candidateLocationId);
      if (normalizedLocationId !== null) {
        return normalizedLocationId;
      }
    }

    return null;
  }

  private getDirectoryDataForSave(): any {
    const directoryDataFromMeta = this.locationMetaInput?.directoryData;
    if (directoryDataFromMeta && typeof directoryDataFromMeta === 'object') {
      return directoryDataFromMeta;
    }

    if (this.directoryData && typeof this.directoryData === 'object') {
      return this.directoryData;
    }

    const pendingDirectoryData = localStorage.getItem(this.PENDING_LOCATION_DIRECTORY_DATA_KEY);
    if (!pendingDirectoryData) {
      return null;
    }

    const parsedPendingDirectoryData = JSON.parse(pendingDirectoryData);
    if (!parsedPendingDirectoryData || typeof parsedPendingDirectoryData !== 'object') {
      return null;
    }

    return parsedPendingDirectoryData;
  }

  callDocAndDirectoryqns(id: any, eventId: any) {
    const resolvedDirectoryData = this.getDirectoryDataForSave();
    if (!resolvedDirectoryData) {
      const error = new Error('Directory data is missing while attempting to save directory responses.');
      this.sharedService.logError("APIFailed", "FileAddLocationComponent - saveDirectory, Method:callDocAndDirectoryqns", this.router.url.split('?')[0], error).subscribe();
      return;
    }

    const normalizedLocationId = this.normalizeLocationId(id);
    if (normalizedLocationId === null) {
      const error = new Error(`Invalid location id (${id}) while attempting to save directory responses.`);
      this.sharedService.logError("APIFailed", "FileAddLocationComponent - saveDirectory, Method:callDocAndDirectoryqns", this.router.url.split('?')[0], error).subscribe();
      return;
    }

    this.directoryData = resolvedDirectoryData;
    const loginUserId = localStorage.getItem("loggedUserId");
    let payload = {
      ...resolvedDirectoryData,
      locationId: normalizedLocationId,
      credentialingEventId: eventId,
      userId: loginUserId ? Number(loginUserId) : 0
    }
    this.sharedService.saveDirectory(payload).subscribe({
      next: (response: any) => {
        if (payload.locationDirectoryId == null) {
          payload.locationDirectoryId = response.locationDirectoryId
          this.directoryArray = [...this.directoryArray, payload]
        } else {
          const index = this.directoryArray.findIndex((item: any) => item.locationDirectoryId == payload.locationDirectoryId);
          if (index != -1) {
            this.directoryArray = this.directoryArray.map((l: any, i: any) => i === index ? { ...l, ...payload } : l);
          }
        }
        localStorage.setItem('locationDirectories', JSON.stringify(this.directoryArray))
        localStorage.removeItem(this.DIRECTORY_INFO_SIGNED_KEY);
        localStorage.removeItem(this.PENDING_LOCATION_DIRECTORY_DATA_KEY);
      }, error: (err: any) => {
        this.sharedService.logError("APIFailed", "FileAddLocationComponent - saveDirectory, Method:callDocAndDirectoryqns", this.router.url.split('?')[0], err).subscribe();
      }
    })
  }


  formatStaticNumberDate(dateString: any): string {
    const date = String(dateString).trim();

    if (!date || date.length !== 8) {
      return "";
    }

    return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
  }

  ValdiatePayeeAddress(tinData: any, payload: any) {
    // Trim so stored placeholder whitespace (e.g. blank NPI) doesn't look like a real edit.
    const norm = (value: any) => (typeof value === 'string' ? value.trim() : value) || null;
    const baselinePayeeName = this.getFirstNonEmpty(tinData, ['payeeName', 'name', 'taxEntityName']);
    const baselinePayeeAddressLine1 = this.getFirstNonEmpty(tinData, ['payeeAddressLine1', 'payeeAddress1', 'address1', 'address', 'location', 'taxEntityAddress1']);
    const baselinePayeeAddressLine2 = this.getFirstNonEmpty(tinData, ['payeeAddressLine2', 'payeeAddress2', 'address2', 'taxEntityAddress2']);
    const baselinePayeeCity = this.getFirstNonEmpty(tinData, ['payeeCity', 'city', 'taxEntityCity']);
    const baselinePayeeState = this.getFirstNonEmpty(tinData, ['payeeState', 'state', 'taxEntityState']);
    const baselinePayeeZip = this.getFirstNonEmpty(tinData, ['payeeZip', 'zip', 'taxEntityZip']);
    if (
      norm(baselinePayeeName) !== norm(payload.payeeName) ||
      norm(baselinePayeeAddressLine1) !== norm(payload.payeeAddressLine1) ||
      norm(baselinePayeeAddressLine2) !== norm(payload.payeeAddressLine2) ||
      norm(baselinePayeeCity) !== norm(payload.payeeCity) ||
      norm(baselinePayeeState) !== norm(payload.payeeState) ||
      norm(baselinePayeeZip) !== norm(payload.payeeZip)
    ) {
      return true;
    }
    return false;
  }

  deleteDocument(fileName: any, subCategoryId: any, documentId?: any) {
    const loginUserId = localStorage.getItem("loggedUserId");
    const credentialingEventId = localStorage.getItem('credentialingEventId');
    const requestParams = {
      "credentialingEventID": Number(credentialingEventId),
      "fileName": fileName,
      "modifiedUserID": loginUserId ? Number(loginUserId) : 0
    }
    this.dentalCredentialingService.deleteDocument(requestParams).subscribe({
      next: (response: any) => {
        const documents = JSON.parse(localStorage.getItem('documents') || '[]');
        const _index = documents.findIndex(
          (item: any) => {
            const itemSubCategoryId = item?.subCategoryId ?? item?.subCategoryID ?? item?.SubCategoryID;
            return `${itemSubCategoryId}` === `${subCategoryId}` &&
            (
              (documentId != null && item.documentId == documentId) ||
              item.fileName === fileName
            );
          }
        );
        if (_index !== -1) {
          documents.splice(_index, 1);
        }
        localStorage.setItem('documents', JSON.stringify(documents));
      }, error: (err: any) => {
        this.sharedService.logError("APIFailed", "FileCreateTinComponent - deleteDocument, Method:deleteDocument", this.router.url.split('?')[0], err).subscribe();
      }
    })
  }

  private clearLocalCorpAuthState(documentId?: any, fileName?: string) {
    const documents = this.getStorageArray('documents');
    const filteredDocuments = documents.filter((item: any) => {
      const itemSubCategoryId = item?.subCategoryId ?? item?.subCategoryID ?? item?.SubCategoryID;
      if (`${itemSubCategoryId}` !== `${DocumentSubCategory.CorporateAuthorityForm}`) {
        return true;
      }
      if (documentId != null && `${item?.documentId}` === `${documentId}`) {
        return false;
      }
      if (fileName && item?.fileName === fileName) {
        return false;
      }
      return true;
    });
    localStorage.setItem('documents', JSON.stringify(filteredDocuments));

    const activeLocationId =
      this.locationMetaInput?.locationId ??
      this.locationMetaInput?.esLocationId ??
      this.locationMetaInput?.locationLookupId ??
      localStorage.getItem('editLocationId');

    const locations = this.getStorageArray('locations');
    const nextLocations = locations.map((location: any) => {
      const matchesDeletedDocument =
        documentId != null && `${location?.dcaDocumentId ?? ''}` === `${documentId}`;
      const isSameLocation =
        activeLocationId != null &&
        (
          `${location?.locationId}` === `${activeLocationId}` ||
          `${location?.esLocationId}` === `${activeLocationId}`
        );
      return (matchesDeletedDocument || isSameLocation)
        ? { ...location, dcaDocumentId: null, isCorpAuthResignRequired: true }
        : location;
    });
    localStorage.setItem('locations', JSON.stringify(nextLocations));

    if (this.locationMetaInput) {
      this.locationMetaInput.dcaDocumentId = null;
    }

    const selectedRecordRaw = sessionStorage.getItem('selectedLocationRecord');
    const selectedRecord = selectedRecordRaw ? JSON.parse(selectedRecordRaw) : null;
    const isSelectedSameLocation = selectedRecord &&
      (
        (documentId != null && `${selectedRecord?.dcaDocumentId ?? ''}` === `${documentId}`) ||
        (activeLocationId != null &&
          (
            `${selectedRecord?.locationId}` === `${activeLocationId}` ||
            `${selectedRecord?.esLocationId}` === `${activeLocationId}`
          ))
      );
    if (isSelectedSameLocation) {
      selectedRecord.dcaDocumentId = null;
      sessionStorage.setItem('selectedLocationRecord', JSON.stringify(selectedRecord));
    }
    this.corpAuthCleared.emit();
  }

  loadLocationDocumentsFromApi(locationId: any) {
    this.dentalCredentialingService.getLocationDocuments(locationId).subscribe({
      next: (response: any) => {
        const rawDocs = Array.isArray(response)
          ? response
          : response
            ? (Array.isArray(response.data) ? response : [response])
            : [response];
        let documents = rawDocs
          .filter((doc: any) => doc && (doc.DocumentID || doc.documentId))
          .map((doc: any) => ({
            ...doc,
            subcategory: doc.SubCategoryName ?? doc.subCategoryName ?? '',
            category: doc.CategoryName ?? doc.categoryName ?? '',
            fileName: doc.FileName ?? doc.fileName ?? '',
            documentId: doc.DocumentID ?? doc.documentId
          }));
        return documents || [];
      },
      error: (err: any) => {
        console.error('Failed to load location documents', err);
        return [];
      }
    });
  }

}
